<template>
  <f7-page class="page-home" name="home" @page:init="onPageInit" @page:beforein="onPageBeforeIn" style="padding-bottom: 20px" @page:beforeUnmount="onPageBeforeunmount">
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-left class="">
        
      </f7-nav-left>
      <f7-nav-title sliding>
        <img  :src="`../static/images/yt999/merchant/${$f7.params.fileName}/logo/dlog.png`" style="height: 42px;" />
      </f7-nav-title>
      <f7-nav-right class="nav-balance">
        <f7-link external target="_blank" :href="dowloadLink" v-if="!isAppDevice && !isIos && dowloadLink != ''">
          <img class="btn-dowload" src="../static/images/yt999/down.png" height="22" />
        </f7-link>
        <f7-link external target="_blank" :href="iosDowloadLink" v-if="!isAppDevice && isIos && iosDowloadLink != ''">
          <img class="btn-dowload" src="../static/images/yt999/down.png" height="22" />
        </f7-link>
        <!-- /member-center/online-cs/ -->
        <f7-link external :target="isAppDevice ? '_self' : '_blank'" v-if="mobileService && mobileService != ''" :href="mobileService">
          <img class="btn-dowload" src="../static/images/yt999/ting.png" height="22" />
        </f7-link>
        <f7-link  @click="$f7router.navigate('/member-center/message-center/2/')">
          <img class="btn-dowload" src="../static/images/yt999/ling.png" height="24" style="margin-right: 10px" />
        </f7-link>
        <!-- <f7-link @click="openChangeLanguagePopup">
          <img class="btn-dowload" src="../static/images/yt999/lang.png" height="24" style="margin-right: 10px" />
        </f7-link> -->
        <!-- <f7-link @click="openChangeCurrencyPopup" class="btn-currency" v-show="currencyList.length > 1">
          <span :class="['icon-currency', 'icon-' + currency]"></span>
          <span class="code">{{ currency }}</span>
        </f7-link> -->
      </f7-nav-right>
    </f7-navbar>

    <div style="background: linear-gradient(180deg, #ffffff 93.51%, #f8f8f8 100%); box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07)">
      <f7-block class="block-banner">
        <f7-swiper pagination next-button prev-button data-lazy="{'enabled': true}" :params="swiperParams" class="swiper-banner" v-if="bannerShow">
          <f7-swiper-slide v-for="(item, index) in bannerList" :key="index">
            <img :src="`${bannerBaseUri + item.Url}`" class="swiper-lazy" />
            <div class="preloader swiper-lazy-preloader"></div>
          </f7-swiper-slide>
        </f7-swiper>
      </f7-block>

      <div class="main-category">
        <marquee :lamplist="lampList"></marquee>
        <div class="menu">
          <div @click="$f7router.navigate('/member-center/withdraw/')">
            <img src="../static/images/yt999/home/ico/ZZicon/qk.png" alt="" srcset="" />
            <span class="">{{ $t("home_0079") }}</span>
          </div>
          <div @click="$f7router.navigate('/member-center/deposit/')">
            <img src="../static/images/yt999/home/ico/ZZicon/ck.png" alt="" srcset="">
            <span>{{ $t("home_0078") }}</span>
          </div>
          <div @click="$f7router.navigate('/member-center/invite-friends-before/')">
            <img src="../static/images/yt999/home/ico/ZZicon/yq.png" alt="" srcset="" />
            <span>{{ $t("invite_friends_0001") }}</span>
          </div>
          <div  @click="$f7router.navigate('/activity/0/')">
            <img src="../static/images/yt999/home/ico/ZZicon/jj.png" alt="" srcset="" />
            <span>{{ $t("app_0005") }}</span>
          </div>

          <!-- <div @click="openRedPacket()">
            <img src="../static/images/yt999/home/ico/ZZicon/red.png" alt="" srcset="" />
            <span>{{ $t("home_0105") }}</span>
          </div> -->
          <!-- <div @click="$f7router.navigate('/cis/')">
            <img src="../static/images/yt999/home/ico/ZZicon/cs.png" alt="" srcset="" />
            <span>{{ $t("home_0080") }}</span>
          </div> -->
          <!-- <div @click="$f7router.navigate('/member-center/vip-list/' + userInfo.VipLevel + '/')">
            <img src="../static/images/yt999/home/ico/ZZicon/vips.png" alt="" srcset="" />
            <span>{{ $t("home_0104") }}</span>
          </div> -->
          <!-- <div @click="$f7router.navigate('/member-center/online-cs/')">
            <img src="../static/images/yt999/i_withdraw.png" alt="" srcset="">
            <span>{{ $t("member_center_0048") }}</span>
          </div> -->
          <!-- <div @click="stayTuned()">
            <img src="../static/images/yt999/home/ico/ZZicon/bzsc.png" alt="" srcset="">
            <span class="">{{ $t("home_0081") }}</span>
          </div> -->
          <!-- <div class="news" @click="$f7router.navigate('/member-center/message-center/2/')">
            <img src="../static/images/yt999/home/ico/ZZicon/xx.png" alt="" srcset="" />
            <span>{{ $t("home_0081") }}</span>
            <span class="messageNum" v-show="userMessageList.length > 0">{{ userMessageList.length }}</span>
          </div> -->
          <!-- <div @click="luckyDrawBoxEntryOpen ? goluckybox() : stayTuned(), { replaceState: true, ignoreCache: true }">
            <img src="../static/images/yt999/home/ico/ZZicon/luckybox.png" alt="" srcset="" />
            <span class="">{{ $t("home_0098") }}</span>
          </div> -->
          <!-- <div @click="$f7router.navigate('/about/')">
            <img src="../static/images/yt999/home/ico/ZZicon/gygs.png" alt="" srcset="" />
            <span class="">{{ $t("home_0085") }}</span>
          </div> -->
          <!-- <div @click="bonus2.Enable?$f7router.navigate('/bonusv2/'):stayTuned2()">
            <img src="../static/images/yt999/home/ico/ZZicon/jifen.png" alt="" srcset="" />
            <span class="">{{ $t("home_0161") }}</span>
          </div> -->
        </div>

      </div>
    </div>
    <div v-if="eventnotifyListFlag" style="width: 85%;margin:auto;">
      <marquee2 :lamplist="eventnotifyList" :key="scrollKey"></marquee2>
    </div>



    <div class="travel">
      <div class="liwu">
        <div class="kuai" @click="luckyDrawBoxEntryOpen?goluckybox():stayTuned()">
          <img src="../static/images/yt999/home/newhome/luck.jpg" alt="" width="100%">
          <!-- <div class="left">
            <div class="t1">{{ $t("home_0171") }}</div>
            <div class="t2"><span class="symbol">{{ currencySymbol }}</span>100 - <span class="symbol">{{ currencySymbol }}</span>1000</div>
          </div> -->
        </div>
        <div class="kuai" @click="openRedPacket()">
          <img src="../static/images/yt999/home/newhome/red.jpg" alt="" width="100%">
          <!-- <div class="left">
            <div class="t1">{{ $t("home_0173") }}</div>
            <div class="t2">{{ $t("home_0174") }} <span class="symbol">{{ currencySymbol }}</span>1000</div>
          </div> -->
        </div>
      </div>

      <div class="vipgo" style="display: flex;" v-if="TeamVipActiveBonusOpen">
        <div class="logo">
          <img src="../static/images/yt999/awardImg.png" alt="" srcset="" width="100%" />
        </div>
        <div style="width: 72%">
          <div class="text1">{{ $t("home_0094") }}</div>
          <div class="text2">{{ $t("home_0095") }}</div>
          <div class="red-button" @click="$f7router.navigate('/award/')">{{ $t("home_0096") }}</div>
        </div>
      </div>


      <div class="tu" @click="$f7router.navigate('/profit/')">
        <img src="../static/images/yt999/home/newhome/img0.png" alt="" width="100%">
        <span>{{ $t("home_0175") }}</span>
      </div>
      <div class="tu" @click="$f7router.navigate(`/member-center/vip-list/${userInfo.VipLevel}/`)">
        <img src="../static/images/yt999/home/newhome/img1.png" alt="" width="100%">
        <span>{{ $t("home_0176") }}</span>
      </div>
      <div class="tu" @click="goMainSite()">
        <img src="../static/images/yt999/home/newhome/img4.png" alt="" width="100%">
        <span>{{ $t("home_0182") }}</span>
      </div>
      <!-- <div class="video">
        <video ref="myVideo" controls playsinline webkit-playsinline  width="100%" style="border-radius: 5px;"></video>
      </div> -->

      <div class="tu" v-if="baseInfo.BonusPointCenterOpen" @click="$f7router.navigate('/integral/')">
        <img src="../static/images/yt999/home/newhome/img3.png" alt="" width="100%">
        <span>{{ $t("home_0177") }}</span>
      </div>

      <!-- <div >
        <div class="home-liveRates" @click="$f7router.navigate('/newsList/')">
          <div class="liveRates-title">
            <span class="title">{{ $t("home_0178") }}</span>
            <i class="f7-icons" style="font-size: 20px;" >chevron_right</i>
          </div>
        </div>
        <div class="news" v-for="(item,index) in newsbyhotList" :key="index" @click="$f7router.navigate(`/newsDetail/${item.Id}/1/`)">
          <div class="txt">
            <div class="t1">{{ item.Title }}</div>
            <div class="t2">{{ item.SubTitle}}</div>
          </div>
          <div class="img">
            <img :src="`${ImagesURL}sr/picture/promotion/${item.PosterMobile}`" height="100%" width="100%">
          </div>
        </div>
      </div> -->

      <div >
        <div class="home-liveRates" >
          <div class="liveRates-title">
            <span class="title">{{ $t("home_0180") }}</span>
            <!-- <i class="f7-icons" style="font-size: 20px;" >chevron_right</i> -->
          </div>
        </div>
        <div class="ygkuai" @click="$f7router.navigate('/staff/')">
          <div class="news" >
            <div class="txt">
              <div class="t1">{{ $t("home_0183") }}</div>
              <div class="t2">{{ $t("home_0184") }}</div>
            </div>
            <div class="img" style="border: none;">
              <img src="../static/images/yt999/home/yghot.png"  width="100%" >
            </div>
          </div>
        </div>
      </div>

      <div v-if="merchantMewsList4.length>0">
        <div class="home-liveRates" >
          <div class="liveRates-title">
            <span class="title">{{ $t("home_0181") }}</span>
            <!-- <i class="f7-icons" style="font-size: 20px;" >chevron_right</i> -->
          </div>
        </div>
        <div class="ygkuai">
          <div class="news" v-for="(item,index) in merchantMewsList4" :key="index" @click="$f7router.navigate(`/newsDetail/${item.Id}/3/`)">
            <div class="txt">
              <div class="t1">{{ item.Title }}</div>
              <div class="t2">{{ item.SubTitle}}</div>
            </div>
            <div class="img">
              <img :src="`${ImagesURL}sr/picture/promotion/${item.PosterMobile}`" width="100%" >
            </div>
          </div>
        </div>
      </div>

      <!-- 热门酒店 -->
      <div class="home-liveRates" v-if="gameRandomList1.length>0">
        <div class="liveRates-title">
          <span class="title">{{ $t("home_0179") }}</span>
          <i class="f7-icons" style="font-size: 20px" @click="$f7router.navigate('/member-center/order-center/0/')">chevron_right</i>
          <!-- <span class="more"><f7-button class="liveRate-popup" popup-open=".demo-popup"></f7-button></span> -->
        </div>
      </div>
      <!-- 热门酒店 -->
      <div class="main-suggest-content" v-if="gameRandomList1.length>0" >
        <f7-swiper :params="swiperNormalOption" @swiper:init="onSwiperInit">
          <f7-swiper-slide v-for="(item, index) in gameRandomList1" :key="index">
            <div class="licaics" >
              <div class="kuai" v-for="(item1, index) in item" :key="index" >
                <div class="one" ><img :src="item1.ProviderGameExtensionData"></div>
                <div class="two" >
                  <p class="name">{{ item1.GameName }}</p>
                  <p class="name2">({{ item1.PreviewImageUrl?item1.PreviewImageUrl.split("|")[1]:'' }})&nbsp;-&nbsp;{{ item1.SubTitle }}</p>
                  <p>                  
                    <van-rate
                      v-model="xingvalue"
                      :size="15"
                      color="#ef9007"
                      void-icon="star"
                      void-color="#eee"
                      @change="onRateChange"/>
                  </p>
                </div>
                <!-- <i class="f7-icons jian" >chevron_right</i> -->
              </div>
            </div>
          </f7-swiper-slide>
        </f7-swiper>
      </div>

      <!-- <div class="home-liveRates" v-if="historytopgetList.length>0">
        <div class="liveRates-title">
          <span class="title">{{ $t("home_0185") }}</span>
          <i class="f7-icons" style="font-size: 20px" @click="luckyDrawBoxEntryOpen?goluckybox():''">chevron_right</i>
        </div>
      </div>
      <div  v-if="historytopgetList.length>0" >
        <van-tabs class="van"  >
          <van-tab  >
            <ul >
              <li class="title">
                <div style="width: 50%">{{ $t("home_0186") }}</div>
                <div style="width: 50%">{{ $t("luckbox_012") }}</div>
              </li>
              <div>
                <li v-for="(item, index) in historytopgetList.slice(0, 10)" :key="index" style="display: flex; ">
                  <div class="d3" style="font-size: 14px"><img src="../static/images/yt999/home/ico/hua.png" height="28" style="margin-right: 8px;">{{ item.UserName }}</div>
                  <div class="d2" v-if="item.WinAmount == 0">
                    <span v-if="item.IsPlayForFun" class="fun"></span> --
                  </div>
                  <div class="d2" v-else>
                    <span v-if="item.IsPlayForFun" class="fun"></span>
                    <span class="symbol">{{ currencySymbol }}</span>{{ item.WinAmount | formatCurrency2 }}
                  </div>
                </li>
              </div >
            
            </ul>
          </van-tab>
        </van-tabs>
      </div> -->

    </div>


    <f7-popup v-show="showLiveRatePopup" class="demo-popup" :opened="popupLiveRateOpened" @popup:open="openLiveRatePopup" @popup:close="closeLiveRatePopup">
      <f7-page>
        <f7-navbar :title="$t('home_0046')">
          <f7-nav-right>
            <f7-link popup-close>
              <i class="f7-icons">multiply_circle</i>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div class="home-liveRates" style="margin-top: 16px">
          <div class="liveRates-content">
            <f7-row no-gap class="liveRates-name">
              <f7-col width="35">{{ $t("home_0038") }}</f7-col>
              <f7-col width="25" class="title-center">{{ $t("home_0039") }}</f7-col>
              <f7-col width="40" class="title-center">{{ $t("home_0040") }}</f7-col>
            </f7-row>
            <div class="liveRate-lists">
              <f7-row v-for="(item, key) of liveRateList" :key="key" no-gap class="rate-item">
                <f7-col width="35">
                  <f7-row no-gap>
                    <f7-col class="country" width="33">
                      <div>
                        <span :class="['icon-country', 'icon-' + item.Source]"></span>
                      </div>
                      <div>
                        <span :class="['icon-country', 'icon-' + item.Target]"></span>
                      </div>
                    </f7-col>
                    <f7-col width="66" class="country-name">
                      <div>{{ item.Source }}/{{ item.Target }}</div>
                      <div>{{ item.Target }}/{{ item.Source }}</div>
                    </f7-col>
                  </f7-row>
                </f7-col>
                <f7-col class="increase" width="25">
                  <div>
                    <img v-if="item.PreviousRate < item.Rate" src="../static/images/yt999/home/up.png" alt="" />
                    <img v-else src="../static/images/yt999/home/down.png" alt="" />
                  </div>
                  <div>
                    <img v-if="item.TargetPreviousRate < item.TargetRate" src="../static/images/yt999/home/up.png" alt="" />
                    <img v-else src="../static/images/yt999/home/down.png" alt="" />
                  </div>
                </f7-col>
                <f7-col class="ask" width="40">
                  <div>{{ item.Rate }}</div>
                  <div>{{ item.TargetRate }}</div>
                </f7-col>
              </f7-row>
            </div>
          </div>
        </div>
      </f7-page>
    </f7-popup>

    <f7-popup v-show="showMarqueePopup" animate backdrop id="popup-marquee" class="popup-marquee" @popup:opened="marqueePopupOpened()" @popup:close="marqueePopupClose">
      <f7-page>
        <f7-navbar :title="$t('home_0009')">
          <f7-nav-right>
            <f7-link popup-close>
              <i class="f7-icons">multiply_circle</i>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block v-if="loadingSkeleton">
          <!-- <f7-card v-for="item in lampList" :key="item.Id" :content="item.Content"
            :footer="item.UpdateTs | time">
          </f7-card> -->
          <f7-card v-for="item in lampList" :key="item.Id" :content="item.Content"></f7-card>
        </f7-block>
        <f7-block v-else>
          <f7-card v-for="item in lampList" :key="item.Id" :content="item.Content"></f7-card>
        </f7-block>
      </f7-page>
    </f7-popup>
    <!-- <div class="dialog dialog-balance dialog-move" @dialog:closed="balanceCloseEvent" @dialog:open="balanceOpenEvent"> -->
    <div class="dialog dialog-balance" @dialog:closed="balanceCloseEvent" @dialog:open="balanceOpenEvent">
      <div class="dialog-inner">
        <div class="dialog-title">
          {{ $t("home_0010") }}
          <f7-link @click="closeDialogBalance">
            <i class="f7-icons">chevron_right</i>
          </f7-link>
        </div>
        <div class="dialog-text">
          <f7-block class="block-balance">
            <f7-block-header class="block-header-totalBalance">
              <f7-row>
                <f7-col width="35">{{ $t("home_0011") }}</f7-col>
                <f7-col width="35">
                  <span v-if="totalWalletFlag">{{ totalBalance | formatCurrency }}</span>
                  <preloader :list="4" v-else></preloader>
                </f7-col>
                <f7-col width="30">
                  <f7-button raised fill class="btn-refresh" @click="getAllBalanceList">{{ $t("home_0012") }}</f7-button>
                </f7-col>
              </f7-row>
              <f7-row>
                <f7-col width="35">{{ $t("home_0013") }}</f7-col>
                <f7-col width="35">
                  <span v-if="totalWalletFlag">{{ walletBalance | formatCurrency }}</span>
                  <preloader :list="4" v-else></preloader>
                </f7-col>
                <f7-col width="30">
                  <f7-button raised fill class="btn-recycling" @click="oneClickRecycling">{{ $t("home_0014") }}</f7-button>
                </f7-col>
              </f7-row>
              <f7-row>
                <f7-col width="35">{{ $t("home_0015") }}</f7-col>
                <f7-col width="35">
                  <span v-if="totalWalletFlag">{{ paddingBalance | formatCurrency }}</span>
                  <preloader :list="4" v-else></preloader>
                </f7-col>
                <f7-col width="30"></f7-col>
              </f7-row>
            </f7-block-header>
            <div class="block-content">
              <f7-row class="item-balance" v-for="item in gameBalanceList" :key="item.ProviderId" :class="`item-balance-${item.ProviderId}`">
                <f7-col width="35">{{ item.Name }}</f7-col>
                <f7-col width="35" class="col-balance">
                  <span v-if="totalWalletFlag">
                    <span v-if="item.IsMaintain">{{ $t("common_under_maintenance") }}</span>
                    <span v-else-if="!item.QuerySuccess">N/A</span>
                    <span v-else>{{ item.Balance | formatCurrency }}</span>
                  </span>
                  <preloader :list="4" v-else></preloader>
                </f7-col>
                <f7-col width="30">
                  <f7-row class="btn-group">
                    <f7-col>
                      <f7-button raised fill class="btn-transfer" :class="{ 'btn-disabled': item.IsMaintain || !item.QuerySuccess }" @click="mainWalletToGame(item)">{{ $t("common_balance_transfer_in") }}</f7-button>
                    </f7-col>
                    <f7-col>
                      <f7-button raised fill class="btn-transferOut" :class="{ 'btn-disabled': item.IsMaintain || !item.QuerySuccess }" @click="gameWalletToMain(item)">{{ $t("common_balance_transfer_out") }}</f7-button>
                    </f7-col>
                  </f7-row>
                </f7-col>
              </f7-row>
            </div>
            <f7-block-footer>
              <f7-row no-gap>
                <f7-col tag="span">
                  <f7-button large class="btn-recharge border-radius-left" @click="jumpPage(0, 'member-center/deposit')">{{ $t("home_deposit") }}</f7-button>
                </f7-col>
                <f7-col tag="span">
                  <f7-button large fill class="btn-withdrawal border-radius-right" @click="jumpPage(0, 'member-center/withdraw')">{{ $t("home_withdrawal") }}</f7-button>
                </f7-col>
              </f7-row>
            </f7-block-footer>
          </f7-block>
        </div>
      </div>
    </div>
    <div class="dialog dialog-message" id="dialog-message">
      <div class="dialog-inner">
        <div class="dialog-title">
          <h3>{{ selectedMessage.Title }}</h3>
          <!-- <h5>{{ selectedMessage.CreateTs | time }}</h5> -->
        </div>
        <div class="dialog-text">
          <f7-block class="block-message">
            <div class="block-content" v-html="selectedMessage.Content"></div>
            <f7-row no-gap class="row-toggle">
              <f7-col></f7-col>
              <f7-col class="text-right">
                <span class="text-14">{{ $t("common_set_readed") }}</span>
                <f7-toggle color="#0887b2" @change="toggleRead" :checked="checkRead"></f7-toggle>
              </f7-col>
            </f7-row>
            <f7-block-footer>
              <f7-row no-gap>
                <f7-col tag="span">
                  <f7-button large class="btn-next border-radius-left" :class="userMessageListShow.length === 1 ? `button-disabled` : ``" @click="nextMessage($event)">{{ $t("common_next") }}</f7-button>
                </f7-col>
                <f7-col tag="span">
                  <f7-button large fill class="btn-close border-radius-right" @click="closeMessagePopup()">{{ $t("common_close") }}</f7-button>
                </f7-col>
              </f7-row>
            </f7-block-footer>
          </f7-block>
        </div>
      </div>
    </div>
    <!-- 广告弹窗 -->
    <div class="dialog dialog-popupAd" id="dialog-popupAd">
      <img @click="closeShowPopupAd()" src="../static/images/yt999/home/cancel.png" class="close" />
      <f7-swiper :params="swiperPopupAd">
        <f7-swiper-slide v-for="(item, index) in popupAdlist" :key="index" style="font-size: 0">
          <div class="block-content" style="max-height: 75vh;overflow-y: auto;overflow-x: clip;">
            <img :src="`${popupAdImgUri + item.Url}`" width="100%" alt="" class="new-player-nav-border" />
          </div>
        </f7-swiper-slide>
      </f7-swiper>
      <div class="swiper-pagination"></div>
      <img :src="swiperPopupAdindex == 0 ? require('../static/images/yt999/home/left2.png') : require('../static/images/yt999/home/left1.png')" class="swiper-button-prev-custom left" width="35" prev-button />
      <img :src="swiperPopupAdindex == popupAdlist.length - 1 ? require('../static/images/yt999/home/right2.png') : require('../static/images/yt999/home/right1.png')" class="swiper-button-next-custom right" width="35" next-button />
    </div>

    <van-popup v-model="bonusv0" closeable close-icon="close" class="bonusv0">
      <div>
        <div style="height: 90px"><img src="../static/images/yt999/bonusred.png" alt="" srcset="" /></div>
        <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px">{{ $t("home_0099") }}</div>
        <div style="margin-bottom: 20px">{{ $t("home_0100") }}</div>
        <div style="font-size: 20px; font-weight: bold; color: red">
          <span style="font-size: 14px">{{ currencySymbol }}</span>
          {{ bonus.MinBonusAmountForText | formatCurrency }} ~
          <span style="font-size: 14px">{{ currencySymbol }}</span>
          {{ bonus.MaxBonusAmountForText | formatCurrency }}
        </div>
        <div style="margin: 20px 0">{{ $t("home_0101") }}</div>
        <div class="go" @click="$f7router.navigate('/bonusv0/')">{{ $t("home_0102") }}</div>
      </div>
    </van-popup>

    <van-popup v-model="bonusv1" closeable close-icon="close" class="bonusv1">
      <div>
        <div style="height: 90px"><img src="../static/images/yt999/bonusred1.png" alt="" srcset="" /></div>
        <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px">{{ $t("home_0103") }}</div>
        <div style="margin-bottom: 20px">{{ $t("home_0100") }}</div>
        <div style="font-size: 20px; font-weight: bold; color: red">
          <span style="font-size: 14px">{{ currencySymbol }}</span>
          {{ bonus1.MinBonusAmountForText | formatCurrency }} ~
          <span style="font-size: 14px">{{ currencySymbol }}</span>
          {{ bonus1.MaxBonusAmountForText | formatCurrency }}
        </div>
        <div style="margin: 20px 0">{{ $t("home_0101") }}</div>
        <div class="go" @click="$f7router.navigate('/bonusv1/')">{{ $t("home_0102") }}</div>
      </div>
    </van-popup>

    <f7-fab position="right-bottom" @click="$f7.dialog.open('#dialog-activity')" v-draggable v-show="missionList.length">
      <div class="fab-contaienr">
        <img class="bg-image" src="../static/images/yt999/hongbao.png" />
        <!-- <img class="icon-close" src="../static/images/yt999/balace.png"> -->
      </div>
    </f7-fab>

    <!-- 抢红包 -->
    <div class="dialog dialog-redPacket" @dialog:closed="messageCloseEvent" @dialog:open="messageOpenEvent">
      <div class="dialog-inner">
        <div class="dialog-title">
          <div class="title">{{ $t("home_0149") }}</div>
        </div>
        <div class="dialog-text">
          <f7-block class="block-message">
            <div class="block-content">
              <p class="tipp">{{ $t("home_0150") }}</p>
              <p>
                <textarea class="input-code" name="" id="" cols="43" rows="9" v-model="redPacketSignal" :placeholder="$t('home_0155')"></textarea>
              </p>
              <p class="red-packet-message">{{ redPacketErrorMessage }}</p>
              <div class="btn">
                <div class="btn1" @click="closeRedPacket()">{{ $t("home_0151") }}</div>
                <div class="btn2" @click="getBonusForGoldenPromoCode()">{{ $t("home_0152") }}</div>
              </div>
            </div>
          </f7-block>
        </div>
      </div>
    </div>

    <!-- 红包详情 -->
    <div class="dialog dialog-redPacketDetail">
      <div class="dialog-inner">
        <img style="height: 225px; position: absolute; right: 0" src="../static/images/yt999/home/red/bi.png" alt="" />
        <div class="dialog-title">
          <div class="title">{{ $t("home_0156") }}</div>
        </div>
        <div class="dialog-text">
          <f7-block class="block-message">
            <div class="block-content">
              <p style="font-weight: bold; font-size: 14px">{{ $t("home_0157") }}</p>
              <p class="money">
                <span class="symbol">{{ currencySymbol }}</span>
                {{ redPacketDetail.FinalBonusAmount | formatCurrency }}
              </p>
              <p style="font-size: 12px">{{ $t("home_0158") }}</p>
              <div class="btn" @click="closeredPacketDetail()">
                {{ $t("home_0159") }}
              </div>
            </div>
          </f7-block>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import marquee from "./template/marquee";
import marquee2 from "./template/marquee2";
import preloader from "./template/preloader";
import api from "../config/api";
import { getCookie, setStore, removeStore, getStore, setCookie } from "../config/utils";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { Draggable } from "draggable-vue-directive";
import {
  getInfo,
  getUserInfo,
  getCarouseladvertList,
  getLampList,
  getBalancesDetail,
  mainWalletToGame,
  gameWalletToMain,
  recyclingFunds,
  getUserNewsList,
  getPopupAd,
  alreadyRead,
  getsimpleviplist,
  rateListget,
  memberFinancialProductbyHotget,
  gameotherrandomlist,
  checkBonus,
  checkRegulaVipEvent,
  getBonusForGoldenPromoCode,
  getbonusForReferralPointsSeasonStatu,
  checkMemberBusinessProgressFlag,
  logout,
  newsbyhotmemberlist,
  getwebsiteinfoGet,
  merchantMewsList,
  hotMerchantNewsLiNst3,
  hotMerchantNewsLiNst4,
  getMemberluckydrawboxhistorytopget,
  eventnotify_1
} from "../axios/api";
import http from "../axios/http";
import common from "../service/common";
import Hls from 'hls.js';


export default {
  components: {
    marquee,
    marquee2,
    preloader,
  },
  directives: {
    Draggable,
  },
  data() {
    const self = this;
    return {
      baseInfo: {},
      isIos: false,
      dowloadLink: "",
      iosDowloadLink: "",
      bonusv0: false,
      bonusv1: false,
      currencySymbol: "",
      lastingDomain: "", //官网地址
      app_version: VERSION,
      promotionPageSize: 3,
      casinoPageSize: 5,
      egamePageSize: 5,
      fishPageSize: 5,
      bannerList: [],
      bannerBaseUri: "",
      bannerShow: false,
      popupAdlist: [],
      popupAdImgUri: "",
      popupAdName: "",
      fishHomeImgUri: "",
      nextPopupAdName: "",
      popupAdIndex: 0,
      lampList: [], //以下关于游戏变量
      promotionList: [],
      loadingSkeleton: true, //加载消息弹窗特效标识
      skeletonTimeout: null, //消息弹窗timeout 对象
      memberBalance: 0, //钱包余额
      gameBalanceList: [], //以下是钱包变量
      simpleVipList_default: ["vip1", "vip2", "vip3", "vip4", "vip5", "vip6", "vip7", "vip8", "vip9", "vip10"],
      simpleVipList: [], //vip 列表变量
      totalWalletFlag: false,
      totalBalance: 0.0,
      walletBalance: 0.0,
      paddingBalance: 0.0,
      infiniteLoading: false, //加载条
      userMessageList: [], //个人消息
      userMessageListShow: [], //个人消息需要弹窗的
      selectedMessage: {},
      checkRead: false,
      messageNum: 0,
      isAppDevice: getStore("device"),
      getInfoStatus: false,
      getGameListStatus: true,
      timeoutStatus: false,
      popupOpened: false,
      mainSiteUrl: "",
      activityDetails: {},
      showLoading: true,
      swiperGameParams: {
        speed: 700,
        loop: false,
        direction: "vertical",
        lazy: {
          loadPrevNext: true,
        },
      },
      swiperParams: {
        speed: 700,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        lazy: {
          loadPrevNext: true,
        },
      },
      swiperNormalOption: {
        loop: false,
        spaceBetween: 12,
        slidesPerView: "auto",
        centeredSlides: true,
      },
      
      swiperParams2: {
        speed: 700, //滑动速度
        loop: true, //重复滚动
        autoplay: {
          disableOnInteraction: false,
          delay: 3000, // 几毫秒后自动播放
        },
      },
      swiperNewPlayerNav: {
        navigation: {
          nextEl: ".swiper-button-next",
        },
      },
      swiperPopupAdindex: 0,
      swiperPopupAd: {
        pagination: {
          el: ".swiper-pagination",
        },
        on: {
          slideChangeTransitionEnd: function () {
            self.slideChangeTransition(this.activeIndex);
            self.swiperPopupAdindex = this.activeIndex;
          },
        },
        navigation: {
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        },
      },
      UniverseSetting: {}, //{0} 天地
      clientWidth: document.documentElement.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      defaultGameListAreaHeight: 509,
      footerHeigh: 70,
      gameCategory: {
        Egames: { name: this.$t("common_0006"), list: [] },
        Lottery: { name: this.$t("common_0011"), list: [] },
        SportsBook: { name: this.$t("common_0010"), list: [] },
        Casino: { name: this.$t("common_0007"), list: [] },
        Card: { name: this.$t("common_0008"), list: [] },
        Fish: { name: this.$t("common_0009"), list: [] },
      },
      autoOpenDialogQueue: [
        { id: "dialog-activity", show: false, check: false, isRead: false },
        { id: "dialog-newPlayerNav", show: false, check: true, isRead: false },
        { id: "dialog-message", show: false, check: false, isRead: false },
        { id: "dialog-popupAd", show: false, check: false, isRead: false },
      ],
      showMarqueePopup: true,
      liveRateList: [],
      liveRateIncludesList: [],
      liveRateListInterval: null,
      popupLiveRateOpened: false,
      showLiveRatePopup: true,
      memberFinancialList: [],
      gameRandomList1: [],
      luckyDrawBoxEntryOpen: false,
      TeamVipActiveBonusOpen: false,
      mobileService: "",
      bonus: {},
      bonus1: {},
      bonus2: {},

      redPacketSignal: "", // 抢红包暗号
      redPacketErrorMessage: "--",
      redPacketDetail: {}, // 红包详情
      ReceivedList: [],
      openRedFlag: true,
      userInfo2: null,

      videoSrc: '',
      newsbyhotList: [],
      ImagesURL: '',
      xingvalue: 5,

      companyIntroduction: '',
      merchantMewsList3: [],
      merchantMewsList4: [],

      historytopgetList:[],   //用户中奖
      eventnotifyTime: null,
      eventnotifyList: [],
      eventnotifyListFlag: false,
      scrollKey: 0
    };
  },
  computed: {
    ...mapState(["currency", "currencyList", "missionList"]),
    ...mapGetters(["getLoginState", "userInfo", "getMerchantInfo", "getAllBalances", "firstLoadApp", "providerCodes"]),
    loadingPopupOpened() {
      return this.$f7router.currentRoute.name == "home" && this.firstLoadApp;
    },

    gameAreaHeight: function () {
      return document.documentElement.clientHeight - 45 - 125 - 30 - 60 - 70 - 6 + "px";
    },
    gameCategoryHeight: function () {
      return document.documentElement.clientHeight - 221 - 12 + "px";
    },
  },

  watch: {
    autoOpenDialogQueue: {
      deep: true,
      handler(queue) {
        if (queue.every((item) => item.check)) {
          const index = queue.findIndex((item) => item.show && !item.isRead);
          if (!~index) {
            return;
          }
          const item = queue[index];
          this.$f7.dialog.open(`#${item.id}`);
        }
      },
    },
  },
  methods: {
    ...mapMutations(["SETMERCHAT_INFO", "SETALLBALANCES", "SETFIRSTLOADAPP", "SETFINANCIAL_DETAIL"]),
    ...mapActions(["getUserInfo", "saveLoginState"]),
    isIOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPhone|iPad|iPod/.test(userAgent);
    },
    geteventnotify_1(){
      const self = this;
      eventnotify_1().then((data) => {
        if (data.Code === "NoError") {
          // self.eventnotifyList = data.Data;
          var ob = null;
          self.eventnotifyList = [];
          data.Data.forEach((item,index) => {
            ob = {
              Id:index,
              Content:self.$t("home_0187",[item.EventDetail.UserName,item.EventDetail.SubMemberVIPName,
              self.currencySymbol,item.EventDetail.MemberCommissionAmount])}
            self.eventnotifyList.push(ob);
            
          });
          if (self.eventnotifyList.length>0) {
            self.eventnotifyListFlag = true;
          }
          // console.log(self.eventnotifyList)
        }
        self.scrollKey++
      });
    },
    
    onSwiperInit(swiper) {
      // 设置 transform 样式为你希望的值
      swiper.setTranslate(0); // 或任意你希望的数值
      swiper.setTransition(0);
    },
    getwebsiteinfoGet(){
      const self = this;
      getwebsiteinfoGet().then((data) => {
        if (data.Code === "NoError") {
          self.companyIntroduction= data.Data.CompanyIntroduction;
        }
      });
    },
    getmerchantMewsList3(){
      const self = this;
      const params = {"NewsType":3,"IsHot":true,"PageSize":10,"PageNow":0};
      let d = JSON.stringify(params);
      hotMerchantNewsLiNst3(d).then((data) => {
        if (data.Code === "NoError") {
          self.merchantMewsList3 = data.Data;
        }
      });
    },

    getmerchantMewsList4(){
      const self = this;
      const params = {"NewsType":4,"IsHot":true,"PageSize":10,"PageNow":0};
      let d = JSON.stringify(params);
      hotMerchantNewsLiNst4(d).then((data) => {
        if (data.Code === "NoError") {
          self.merchantMewsList4 = data.Data;
        }
      });
    },
    
    //敬请期待
    stayTuned() {
      const self = this;
      self.$f7.toast
        .create({
          text: this.$t("home_0093"),
          position: "center",
          closeTimeout: 1000,
          cssClass: "toast-login",
          on: {
            closed: function () {
              // router.navigate("/");
            },
          },
        })
        .open();
    },
    //兑换积分活动未开启
    stayTuned2() {
      const self = this;
      self.$f7.toast
        .create({
          text: this.$t("home_0162"),
          position: "center",
          closeTimeout: 1000,
          cssClass: "toast-login",
          on: {
            closed: function () {
              // router.navigate("/");
            },
          },
        })
        .open();
    },
    getImageURL(code, id) {
      return "../static/images/yt999/home/" + code + id + ".png";
    },
    getgameRandomList() {
      const self = this;
      const params = {"TopNum":15,"SizeNum":3};
      let d = JSON.stringify(params);
      gameotherrandomlist(d).then((data) => {
        if (data.Code == "NoError") {
          self.gameRandomList1 = data.Data;
        }
      });
    },

    //获取最新理财产品
    getMemberfinancialproductbyhotget() {
      const self = this;
      memberFinancialProductbyHotget().then((data) => {
        if (data.Code == "NoError") {
          self.memberFinancialList = data.Data;
        }
      });
    },
    goToFinancialDetail(item) {
      let index = 0;
      if (item.FinancialProductType == "LowRiskProducts") {
        index = 0;
      } else if (item.FinancialProductType == "HighYieldProducts") {
        index = 1;
      } else if (item.FinancialProductType == "CharityDonationProducts") {
        index = 2;
      } else if (item.FinancialProductType == "ExclusiveFundProducts") {
        index = 3;
      }
      this.$f7router.navigate(`/member-center/financial-detail/${JSON.stringify({ index: index, financialid: item.FinancialProductID })}/`);
    },
    getSimpleVipList() {
      const self = this;
      const params = {"ShowDefault":true};
      let d = JSON.stringify(params);
      getsimpleviplist(d).then((data) => {
        if (data.Code === "NoError") {
          self.simpleVipList = data.Data;
        }
      });
    },
    checkBonus() {
      const self = this;
      checkBonus().then((data) => {
        if (data.Code === "NoError") {
          self.bonus = data.Data;
          if (data.Data.Enable) {
            self.bonusv0 = true;
          } else {
            checkRegulaVipEvent().then((data) => {
              if (data.Code === "NoError") {
                if (data.Data.Enable) {
                  self.bonus1 = data.Data;
                  self.bonusv1 = true;
                }
              }
            });
          }
        }
      });
    },
    newsbyhotmemberlist(){
      const self = this;
      const param = { "TopNum":3,"NewsType":1 };
      const d = JSON.stringify(param);
      newsbyhotmemberlist(d).then((data) => {
        if (data.Code === "NoError") {
          this.newsbyhotList = data.Data;
        }
      });
    },
    getInfo() {
      const self = this;
      getInfo().then((data) => {
        if (data.Code === "NoError" && data.Data) {
          self.getInfoStatus = true;
          const d = data.Data;
          self.baseInfo = d.BaseInfo;
          self.ImagesURL = d.ImagesURL;
          self.SETMERCHAT_INFO(d); //存储Vuex store merchantinfo
          setStore(`currencySymbol`, d.BaseInfo.DefaultCurrencySymbol);
          self.currencySymbol = d.BaseInfo.DefaultCurrencySymbol;
          self.lastingDomain = d.BaseInfo.LastingDomain;
          setStore(`ImagesURL`, d.ImagesURL);
          setStore("ShowTW", data.Data.BaseInfo.ShowTW);
          setStore(`AboutUsMediaUrl`, d.BaseInfo.AboutUsMediaUrl);
          setStore(`TimeZoneString`, d.BaseInfo.TimeZoneString || this.$Common_TimeZoneString_Default);
          setStore(`TimeZone`, d.BaseInfo.TimeZome || this.$Common_TimeZone_Default);
          setStore(`TimeZoneFMT`, d.BaseInfo.TimeZoneFMT || this.$Common_TimeZoneFMT_Default);
          setStore(`DateTimeFMT`, d.BaseInfo.DateTimeFMT || this.$Common_DateTimeFMT_Default);
          setStore(`DateFMT`, d.BaseInfo.DateFMT || this.$Common_DateFMT_Default);
          self.videoSrc = d.BaseInfo.AboutUsMediaUrl;
          if (d.GameImagesURL && d.GameImagesURL != "") {
            setStore(`GameImagesURL`, d.GameImagesURL); // 电子游艺游戏图片
          }
          self.bannerBaseUri = d.ImagesURL + window.configs.carouseladvertImg;
          self.fishHomeImgUri = d.GameImagesURL + (window.configs.fishHomeImg == null ? "static/images/fish/mobile/" : window.configs.fishHomeImg);
          // self.dowloadLink = d.BaseInfo.AppSite;
          self.dowloadLink = d.BaseInfo.AppDownloadSite;
          self.iosDowloadLink = d.BaseInfo.AppDownloadSite_iOS;
          self.mobileService = d.BaseInfo.MobileService;
          self.UniverseSetting = d.UniverseSetting;
          self.getBannerList(2);
          self.mainSiteUrl = d.BaseInfo.LastingDomain;
          self.luckyDrawBoxEntryOpen = d.BaseInfo.LuckyDrawBoxEntryOpen;
          self.TeamVipActiveBonusOpen = d.BaseInfo.TeamVipActiveBonusOpen;
          getUserInfo().then((data) => {
            if (data.Code === "NoError") {
              self.userInfo2 = data.Data;
              if (!self.userInfo2.IsDefaultVIPLevel) {
                self.appUpdateReminder(); //app版本更新提示
              }
              // if (self.userInfo2.IsDefaultVIPLevel == false && self.baseInfo.BusinessProgressFlag == 1) {
              //   if (self.baseInfo.EnableMemberDocumentsInfoVerify && (self.userInfo2.MemberDocumentsInfo.VerifyStatus == "NotVerify" || self.userInfo2.MemberDocumentsInfo.VerifyStatus == "VerifyFailed")) {
              //     self.$f7.$(".dialog-backdrop").css("background-color", "rgba(0, 0, 0, 0.74)");
              //     self.$f7.dialog
              //       .create({
              //         closeByBackdropClick: false,
              //         title: this.$t("common_0004"),
              //         text: this.$t("member_info_0048"),
              //         cssClass: "dialog-logout",
              //         buttons: [
              //           {
              //             text: this.$t("common_0001"),
              //             cssClass: "dialog-ok",
              //             onClick: () => {
              //               self.$f7.$(".dialog-backdrop").css("background", "transparent");
              //               self.$f7router.navigate("/member-center/member-info/tab-identity/");
              //             },
              //           },
              //         ],
              //       })
              //       .open();
              //   } else {
              //     if (self.baseInfo.EnableBusinessProgressFlag == true) {
              //       self.checkMemberBusinessProgressFlag();
              //     }
              //   }
              // }
            }
          });

          // self.userInfo2 = JSON.parse(getStore("userInfo"));
        }
      });
    },
    getLiveRateList() {
      const self = this;
      if (self.liveRateListInterval) {
        clearInterval(self.liveRateListInterval);
      }
      const params = {
        source_curr_code: "USD",
        curr_code: [],
      };
      const d = { data: JSON.stringify(params) };
      rateListget(d).then((res) => {
        if (res.Code === "NoError") {
          self.updateLiveRateList();
          const targetValues = ["EUR", "JPY", "AUD", "CAD"];
          self.liveRateList = res.Data;
          self.liveRateIncludesList = res.Data.filter((item) => {
            const targetUpperCase = item.Target.toUpperCase();
            return targetValues.includes(targetUpperCase);
          });
        }
      });
    },
    updateLiveRateList() {
      const self = this;
      if (self.liveRateListInterval) {
        clearInterval(self.liveRateListInterval);
      }
      // self.liveRateListInterval = setInterval(() => {
      //   self.getLiveRateList();
      // }, 30000);
    },
    getUserMemberBalance() {
      const self = this;
      self.memberBalance = null;
      getBalancesDetail().then((data) => {
        if (data.Code === "NoError") {
          const res = data.Data;
          self.memberBalance = data.Data.Balance;
        }
      });
    },
    getBannerList(param) {
      const self = this;
      getCarouseladvertList(param).then((data) => {
        if (data.Code === "NoError") {
          self.bannerShow = true;
          self.bannerList = data.Data;
        }
      });
    },
    getLampList() {
      const self = this;
      getLampList().then((data) => {
        if (data.Code === "NoError") {
          self.lampList = data.Data;
        }
      });
    },
    getFishList() {},
    detail(item) {
      this.activityDetails = item;
      this.popupOpened = true;
    },
    goMainSite() {
      if (this.mainSiteUrl != "") {
        window.open(this.mainSiteUrl, "_blank");
      }else{
        this.stayTuned();
      }
    },
    promptMaintain(content) {
      const self = this;
      self.$f7.params.dialog.closeByBackdropClick = false;
      //self.$f7.$('.dialog-backdrop').css('background-color', 'transparent');
      let promptMaintain = self.$f7.dialog
        .create({
          title: "",
          text: content,
          cssClass: "dialog-game",
        })
        .open();
      setTimeout(() => {
        self.$f7.params.dialog.closeByBackdropClick = true;
        //self.$f7.$('.dialog-backdrop').css('background-color', 'rgba(0, 0, 0, 0.74)');
        promptMaintain.close();
      }, 2000);
    },
    goGameList(id) {
      this.$f7router.navigate(`/game-list/${id}/`);
    },
    goFishGameList() {
      this.$f7router.navigate(`/fish-list/`);
    },
    showDeterminate(multiColor) {
      // 顶部 progressbar加载条
      const self = this;
      const app = self.$f7;
      if (self.infiniteLoading) return;
      self.infiniteLoading = true;
      if (multiColor) {
        app.progressbar.show("multi");
      } else {
        app.progressbar.show(app.theme === "md" ? "yellow" : "blue");
      }
    },
    async getValidProviders() {
      const self = this;
      let res = await http.post(api.validproviders);
      if (res.Code === "NoError") {
        self.$f7.params.dialog.closeByBackdropClick = true; //点击背景关闭
        self.$f7.dialog.open(".dialog-balance", true);
        self.gameBalanceList = res.Data;
        self.getAllBalanceList();
      }
    },
    getAllBalanceList() {
      const self = this;
      self.totalWalletFlag = false; //总钱包余额是否请求完成标识
      getBalancesDetail().then((data) => {
        if (data.Code === "NoError") {
          const res = data.Data;
          self.totalWalletFlag = true;
          self.SETALLBALANCES(res); //存储Vuex store balance
          self.totalBalance = data.Data.Balance;
          self.paddingBalance = data.Data.FreezeAmount;
          self.walletBalance = data.Data.Balance;
        }
      });
    },
    getMissionList() {
      // const self = this;
      // getMissionList().then((data) => {
      //   const item = this.autoOpenDialogQueue.find((item) => item.id == "dialog-activity");
      //   if (data.Code === "NoError" && data.Data) {
      //     self.$store.commit("SET_MISSION_LIST", data.Data);
      //     const unShow = /true/.test(getCookie("unShow"));
      //     if (Array.isArray(data.Data) && data.Data.length && !unShow) {
      //       item.show = true;
      //     } else {
      //       item.show = false;
      //     }
      //     item.check = true;
      //   }
      // });
    },
    jumpPage(type, param) {
      const self = this;
      const router = self.$f7router;
      if (type === 0) {
        //balance popup 弹窗
        self.$f7.dialog.close(".dialog-balance");
        router.navigate(`/${param}/`);
      }
    },
    oneClickRecycling(event) {
      const self = this;
      if (!self.totalWalletFlag) return;
      self.$f7.$(".btn-recycling").addClass("progressbar");
      self.$f7.$(".btn-recycling").text(this.$t("common_game_balance_transfer_back"));
      recyclingFunds().then((data) => {
        self.$f7.$(".btn-recycling").removeClass("progressbar");
        self.$f7.$(".btn-recycling").text(this.$t("common_one_key_transfer_game_balance_back"));
        if (data.Code === "NoError") {
          self.getAllBalanceList();
        }
      });
    },
    mainWalletToGame(item) {
      const self = this;
      if (!self.totalWalletFlag || item.IsMaintain || !item.QuerySuccess || !self.walletBalance) return;
      const params = {
        ProviderId: item.ProviderId,
        Amount: self.walletBalance,
      };
      const d = { data: JSON.stringify(params) };
      self.$f7.$(`.item-balance-${item.ProviderId}`).addClass("progressbar");
      mainWalletToGame(d).then((data) => {
        setTimeout(() => {
          self.$f7.$(`.item-balance-${item.ProviderId}`).removeClass("progressbar");
        }, 1000);
        if (data.Code === "NoError") {
          self.getAllBalanceList();
        }
      });
    },
    gameWalletToMain(item) {
      const self = this;
      if (!self.totalWalletFlag || item.IsMaintain || !item.QuerySuccess || !item.Balance) return;
      const params = {
        ProviderId: item.ProviderId,
        Amount: item.Balance,
      };
      const d = { data: JSON.stringify(params) };
      self.$f7.$(`.item-balance-${item.ProviderId}`).addClass("progressbar");
      gameWalletToMain(d).then((data) => {
        setTimeout(() => {
          self.$f7.$(`.item-balance-${item.ProviderId}`).removeClass("progressbar");
        }, 1000);
        if (data.Code === "NoError") {
          self.getAllBalanceList();
        }
      });
    },
    marqueePopupOpened() {
      var self = this;
      self.showMarqueePopup = true;
      self.skeletonTimeout = setTimeout(() => {
        self.loadingSkeleton = false;
      }, 3000);
    },
    marqueePopupClose() {
      clearTimeout(this.skeletonTimeout);
      this.loadingSkeleton = true;
      this.showMarqueePopup = false;
    },
    openLiveRatePopup() {
      this.showLiveRatePopup = true;
    },
    closeLiveRatePopup() {
      this.popupLiveRateOpened = false;
      this.showLiveRatePopup = false;
    },
    openChangeLanguagePopup() {
      const self = this;
      self.$f7.params.dialog.closeByBackdropClick = true; //点击背景关闭
      self.$f7.dialog.open("#dialog-change-language", true);
    },
    openChangeCurrencyPopup() {
      const self = this;
      self.$f7.params.dialog.closeByBackdropClick = true; //点击背景关闭
      self.$f7.dialog.open("#dialog-change-currency", true);
    },
    openBalancePopup() {
      const self = this;
      if (self.getLoginState) {
        self.getValidProviders();
      } else {
        this.$f7router.navigate("/login/");
      }
    },
    closeDialogBalance() {
      this.$f7.dialog.close(".dialog-balance");
    },
    balanceOpenEvent() {
      this.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
    },
    balanceCloseEvent() {
      this.$f7.$(".dialog-backdrop").css("background", "transparent");
    },
    getUserNewsListEvent() {
      const self = this;
      const param = {
        data: JSON.stringify({
          Status: 2,
          BeginDate: 0,
          EndDate: 0,
          PageNow: 1,
          PageSize: 100,
        }),
      };
      const item = self.autoOpenDialogQueue.find((item) => item.id == "dialog-message");
      getUserNewsList(param).then((data) => {
        if (data.Code === "NoError" && data.Data.Total > 0) {
          self.userMessageList = data.Data.Data;
          self.userMessageListShow = data.Data.Data.filter((item) => item.ShowType === 2);
          if (self.userMessageListShow.length <= 0) {
            return;
          }
          self.selectedMessage = self.userMessageListShow[self.messageNum];
          self.$f7.params.dialog.closeByBackdropClick = false; //点击背景不关闭
          item.show = true;
          self.$f7.dialog.open(".dialog-message");
        }

        item.check = true;
      });
    },
    showNewPlayerNav() {
      const self = this;
      self.$f7.params.dialog.closeByBackdropClick = false; //点击背景不关闭
      // self.$f7.dialog.open('.dialog-newPlayerNav');
      const item = this.autoOpenDialogQueue.find((item) => item.id == "dialog-newPlayerNav");
      item.check = true;
      item.show = true;
      removeStore("showNewPlayerNav");
    },
    showNewPopupAd() {
      const self = this;
      const param = {
        data: JSON.stringify({
          Type: 4,
        }),
      };
      getPopupAd(param).then((data) => {
        const item = this.autoOpenDialogQueue.find((item) => item.id == "dialog-popupAd");
        item.check = true;
        if (data.Code === "NoError" && data.Data.Status && data.Data.CarouselAdvert.length > 0) {
          self.popupAdlist = data.Data.CarouselAdvert;
          self.popupAdName = self.popupAdlist[0].Name;
          if (self.popupAdlist.length > 1) {
            self.nextPopupAdName = self.popupAdlist[1].Name;
          } else {
            self.nextPopupAdName = this.$t("common_have_no_next");
          }
          self.popupAdImgUri = getStore(`ImagesURL`) + window.configs.popupAdImg;
          self.$f7.params.dialog.closeByBackdropClick = false; //点击背景不关闭
          self.$f7.dialog.open(".dialog-popupAd");
          item.show = true;
          sessionStorage.setItem("mainPopup", 1);
        }
        if (getCookie("zz")) {
          self.getUserNewsListEvent();
        } else {
          const item = self.autoOpenDialogQueue.find((item) => item.id == "dialog-message");
          item.check = true;
        }
      });
    },
    messageOpenEvent() {
      this.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
    },
    messageCloseEvent() {
      this.$f7.$(".dialog-backdrop").css("background", "transparent");
    },
    toggleRead() {
      if (this.checkRead) {
        this.checkRead = false;
      } else {
        this.checkRead = true;
      }
    },
    nextMessage(event) {
      const self = this;
      self.messageNum++;
      if (self.messageNum < self.userMessageListShow.length) {
        if (self.checkRead) {
          alreadyRead({ data: self.selectedMessage.Id }).then((data) => {});
        }
        self.selectedMessage = self.userMessageListShow[self.messageNum];
        if (self.messageNum === self.userMessageListShow.length - 1) {
          self.$f7.$(event.currentTarget).addClass("button-disabled");
        }
      }
    },
    slideChangeTransition(index) {
      const self = this;
      self.popupAdName = self.popupAdlist[index].Name;
      if (self.popupAdlist.length - 1 > index) {
        self.nextPopupAdName = self.popupAdlist[index + 1].Name;
      } else {
        self.nextPopupAdName = this.$t("common_have_no_next");
      }
    },
    getPromotionList() {
      // const self = this;
      // const params = { data: JSON.stringify({ Type: 0 }) };
      // getActivityList(params).then((data) => {
      //   if (data.Code === "NoError") {
      //     self.promotionList = [];
      //     var current_flag = 0;
      //     var arr = [];
      //     for (let index = 0; index < data.Data.length; index++) {
      //       const element = data.Data[index];
      //       if (element.Type == 5) {
      //         arr[arr.length] = element;
      //         current_flag++;
      //         if (current_flag == self.promotionPageSize) {
      //           self.promotionList[self.promotionList.length] = arr;
      //           current_flag = 0;
      //           arr = [];
      //         }
      //       }
      //     }
      //   }
      // });
    },
    gohome() {
      window.open(this.lastingDomain, "_blank");
    },
    goluckybox() {
      this.$f7router.navigate("/luckybox/");
    },
    closeMessagePopup() {
      const self = this;
      if (self.checkRead) {
        const param = { data: self.selectedMessage.Id };
        alreadyRead(param).then((data) => {});
      }
      self.$f7.dialog.close("#dialog-message");
      const item = self.autoOpenDialogQueue.find((item) => item.id == "dialog-message");
      item.isRead = true;
    },
    closeShowNewPlayerNav() {
      const self = this;
      self.$f7.dialog.close(".dialog-newPlayerNav");
      const item = self.autoOpenDialogQueue.find((item) => item.id == "dialog-newPlayerNav");
      item.isRead = true;
    },
    closeShowPopupAd() {
      const self = this;
      self.$f7.dialog.close(".dialog-popupAd");
      const item = this.autoOpenDialogQueue.find((item) => item.id == "dialog-popupAd");
      item.isRead = true;
    },
    loadingStatusEvent() {
      const self = this;
      const start = new Date();
      let timeoutShowReload = setInterval(() => {
        const end = new Date();
        let time = (end - start) / 1000;
        if (time >= 10) {
          self.timeoutStatus = true;
          clearInterval(timeoutShowReload);
        }
      }, 1000);
      let loadingInterval = setInterval(() => {
        const end = new Date();
        let time = (end - start) / 1000;
        if (time > 3) {
          if (this.firstLoadApp && this.bannerShow && this.getInfoStatus) {
            //this.loadingPopupOpened = false;
            this.showLoading = false;
            this.$f7.popup.close(".loadding-popup");
            this.SETFIRSTLOADAPP(false);
            clearInterval(loadingInterval);
            clearInterval(timeoutShowReload);
          }
        }
      }, 1000);
    },
    onPageInit(e, page) {
      const self = this;
      if (self.liveRateListInterval) {
        clearInterval(self.liveRateListInterval);
      }
      //if (page.router.currentRoute.name == "home") {
      self.$f7ready((f7) => {
        if (self.firstLoadApp) {
          self.loadingStatusEvent();
        }
        //self.showDeterminate(false);
        self.getInfo();
        self.getLampList();
        // self.newsbyhotmemberlist();


        // self.getGameList();
        self.getFishList();
        self.getPromotionList();
        self.getMissionList();
        // self.getSimpleVipList();
        self.getMemberfinancialproductbyhotget();
        self.getgameRandomList();
        // self.getmerchantMewsList3();
        self.getmerchantMewsList4();
        self.checkBonus();
        self.getbonusForReferralPointsSeasonStatu();
        self.onHls();

        self.geteventnotify_1();
        self.eventnotifyTime = setInterval(() => {
          this.geteventnotify_1();
        }, 120000);

        // self.getLiveRateList();
        if (getStore("zz") != "") {
          this.getUserInfo();

          this.getUserMemberBalance();
        }

        //广告弹窗
        self.showNewPopupAd();
        // if (!sessionStorage.getItem("mainPopup")) {
        //   self.showNewPopupAd();
        // }

        //新手引导
        // if (getStore('showNewPlayerNav')) {
        //   self.showNewPlayerNav();
        // }
        //if (getCookie("zz") && page.router.currentRoute.name == "home") {

        //用户中奖
        // this.getMemberluckydrawboxhistorytopget();
        // this.updateTime = setInterval(() => {
        //   this.getMemberluckydrawboxhistorytopget();
        // }, 10000);

        self.$f7.on("onCloseDialog", (targetId) => {
          const item = self.autoOpenDialogQueue.find((item) => item.id == targetId);
          if (item) {
            item.isRead = true;
          }
        });
      });
      //}
    },
    getMemberluckydrawboxhistorytopget() {
      getMemberluckydrawboxhistorytopget().then((data) => {
        if (data.Code === "NoError") {
          this.historytopgetList = data.Data;
        }
      });
    },
    checkMemberBusinessProgressFlag() {
      const self = this;
      const param = { BusinessProgressFlag: this.baseInfo.BusinessProgressFlag };
      const d = { data: JSON.stringify(param) };
      checkMemberBusinessProgressFlag(d).then((data) => {
        if (data.Code === "NoError") {
          if (!data.Data.IsComplete) {
            self.$f7.$(".dialog-backdrop").css("background-color", "rgba(0, 0, 0, 0.74)");
            self.$f7.dialog
              .create({
                closeByBackdropClick: false,
                title: "",
                text: `<div>` + self.$t("home_0164") + ` ` + self.userInfo2.VipLevelName + ` ` + self.$t("home_0165") + `<br/>` + self.$t("home_0166") + `：<br/><span class="symbol">` + self.currencySymbol + `</span>` + self.$options.filters.formatCurrency2(data.Data.CompletionCondition) + `</div>`,
                buttons: [
                  {
                    text: self.$t("home_0167"),
                    onClick: () => {
                      self.$f7.$(".dialog-backdrop").css("background", "transparent");
                      logout().then((data) => {
                        common.logoutEvent(self);
                        self.saveLoginState();
                        self.$f7router.navigate("/login/");
                      });
                    },
                  },
                  {
                    text: self.$t("home_0168"),
                    onClick: () => {
                      self.$f7.$(".dialog-backdrop").css("background", "transparent");
                      self.$f7router.navigate("/member-center/deposit/");
                    },
                  },
                ],
              })
              .open();
          }
        }
      });
    },
    onPageBeforeIn() {
      this.$f7.emit("myCustomEvent", "home");
      removeStore("mc-tab-active");
    },
    onPageBeforeunmount() {
      clearInterval(this.liveRateListInterval);
    },
    onRateChange(val) {
      if (val < 5) {
        this.xingvalue = 5;
      }
    },
    goUniverse(type) {
      const self = this;
      if (type === "") {
        let promtLoadingGame = self.$f7.dialog
          .create({
            title: "",
            text: this.$t("common_keep_waiting"),
            cssClass: "dialog-preloadgame",
          })
          .open();
        self.$f7.params.dialog.closeByBackdropClick = false;
        //self.$f7.$('.dialog-backdrop').css('background-color', 'transparent');
        setTimeout(() => {
          promtLoadingGame.close();
        }, 1500);
        return;
      }
      var mreturn = "";
      if (!getStore("device")) {
        mreturn = btoa(window.location.protocol + "//" + window.location.host);
      } else {
        const d = localStorage.getItem("d") && localStorage.getItem("d") != "" ? localStorage.getItem("d") : "";
        const appVer = localStorage.getItem("appVer") && localStorage.getItem("appVer") != "" ? localStorage.getItem("appVer") : "";
        const appHref = window.location.protocol + "//" + window.location.host + "/#/app/?d=" + d + "&device=App&appVer=" + appVer;
        mreturn = btoa(appHref);
      }
      const regist = btoa(window.location.protocol + "//" + window.location.host + "/#/register/");
      const href = `${type}?platform=mobile&system=${self.UniverseSetting.SystemCode}&merchant=${window.configs.merchantAlias}&token=${getCookie("zz") ? getCookie("zz") : ""}&return=${mreturn}&regist=${regist}`;
      if (!getStore("device")) {
        this.common.redirectURL(href);
      } else {
        let promtLoadingGame = self.$f7.dialog
          .create({
            title: "",
            text: this.$t("home_TV_loading", [this.$f7.params.shortName]),
            cssClass: "dialog-preloadgame",
          })
          .open();
        self.$f7.params.dialog.closeByBackdropClick = false;
        //self.$f7.$('.dialog-backdrop').css('background-color', 'transparent');
        setTimeout(() => {
          promtLoadingGame.close();
        }, 1500);
        window.location.href = href;
      }
    },
    //app更新提示
    appUpdateReminder() {
      const self = this;
      var device = getStore("device");
      //if (getStore("device")) {
      //是App
      const isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isApple) {
        //苹果手机
        if (getStore("appVer") !== self.baseInfo.IOSAppVersion.toString() && self.baseInfo.IOSAppUpdateMessageShow) {
          // self.$f7.dialog.alert(this.$t("home_0163"), this.$t("common_0004"));
          self.appDownTip();
        }
      } else {
        if (getStore("appVer") !== self.baseInfo.AndroidAppVersion.toString() && self.baseInfo.AndroidAppUpdateMessageShow) {
          // self.$f7.dialog.alert(this.$t("home_0163"), this.$t("common_0004"));
          self.appDownTip();
        }
      }
      //}
    },
    appDownTip() {
      const self = this;
      self.$f7.$(".dialog-backdrop").css("background-color", "rgba(0, 0, 0, 0.74)");
      self.$f7.dialog
        .create({
          closeByBackdropClick: false,
          title: this.$t("common_0004"),
          text: this.$t("home_0163"),
          buttons: [
            {
              text: self.$t("common_0002"),
              onClick: () => {
                self.$f7.$(".dialog-backdrop").css("background", "transparent");
                logout().then((data) => {
                  common.logoutEvent(self);
                  self.saveLoginState();
                  self.$f7router.navigate("/login/");
                });
              },
            },
            {
              text: self.$t("home_0170"),
              close: false,
              onClick: () => {
                window.location.href = self.dowloadLink;
              },
            },
          ],
        })
        .open();
    },
    openRedPacket() {
      const self = this;
      self.$f7.dialog.open(".dialog-redPacket");
    },
    closeRedPacket() {
      const self = this;
      self.redPacketSignal = "";
      self.redPacketErrorMessage = "--";
      self.openRedFlag = true;
      self.$f7.dialog.close(".dialog-redPacket");
    },
    openredPacketDetail() {
      const self = this;
      self.$nextTick(() => {
        self.$f7.dialog.open(".dialog-redPacketDetail", true);
        self.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
      });
    },
    closeredPacketDetail() {
      const self = this;
      self.$f7.dialog.close(".dialog-redPacketDetail");
    },
    getBonusForGoldenPromoCode() {
      const self = this;
      if (self.redPacketSignal == "") {
        self.redPacketErrorMessage = self.$i18n.t("home_0107");
        setTimeout(() => {
          self.redPacketErrorMessage = "--";
        }, 2500);
        return;
      }
      if (!self.openRedFlag) {
        return;
      }
      self.openRedFlag = false;
      self.redPacketErrorMessage = self.$i18n.t("home_0160");
      const param = {
        data: JSON.stringify({
          Key: self.redPacketSignal,
        }),
      };
      getBonusForGoldenPromoCode(param).then((data) => {
        if (data.Code === "NoError") {
          self.redPacketDetail = data.Data;
          self.closeRedPacket();
          self.openredPacketDetail();
        } else {
          // self.$f7.dialog.alert(data.Data,self.$i18n.t('common_0004'));
          self.redPacketErrorMessage = data.Data;
        }
        self.openRedFlag = true;
      });
    },
    getbonusForReferralPointsSeasonStatu() {
      getbonusForReferralPointsSeasonStatu().then((data) => {
        if (data.Code === "NoError") {
          this.bonus2 = data.Data;
        }
      });
    },
    onHls() {
      if (Hls.isSupported()) {
        const video = this.$refs.myVideo;
        const hls = new Hls();
        hls.loadSource(this.videoSrc);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          // video.play();
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.videoSrc;
        video.addEventListener('canplay', () => {
          // video.play();
        });
      }
    },

    activeTab(e) {},
    //关闭所有弹窗
    closeAllModals() {
      this.actionServiceOpened = false;
      this.actionPromotionOpened = false;
      this.actionTransferOpened = false;
      this.actionQQ = false;
      this.actionWechat = false;
      this.onlinePopupOpened = false;
      this.showOnlinePopup = false;

      this.$f7.dialog.close();
      this.$f7.popup.close();
      this.$f7.actions.close();
    },
    setOffsetTop() {},
  },
  created() {
    this.isIos = this.isIOS();
    const d = this.$f7route.query.d;
    const r = this.$f7route.query.r;
    setStore("d", d);
    setStore("r", r);
  },
  mounted() {
    window.addEventListener("resize", function () {
      //-45 顶部
      //-10 消息和user info中间10间距
      //-90 user info高度
      //-6  game area margin 6
      //-70 底部菜单
      // SUM = -221
      this.clientHeight = document.body.clientHeight;
      this.clientWidth = document.body.clientWidth;

      this.$refs.hotelSwiper.swiper.setTranslate(13.625); // px
      this.$refs.hotelSwiper.swiper.updateActiveIndex();

    });
  },
  beforeDestroy() {
    if (this.liveRateListInterval) {
      clearInterval(this.liveRateListInterval);
    }
    if (this.eventnotifyTime) {
      clearInterval(this.eventnotifyTime);
    }
    this.closeShowPopupAd();
    this.closeAllModals();
  },
  updated() {
    this.$f7.lazy.create(this.$el);
  },
};
</script>

<style lang="less" scoped>

.travel{
  .liwu{
    display: grid;
    grid-template-columns: 1fr 1fr; 
	  grid-gap: 10px;
    margin-bottom: 10px;
    .kuai{
      position: relative;
      display: flex;
      align-items: center;
      .left{
        position: absolute;
        right: 10%;
        .t1{
          color: #ff790b;
          font-weight: bold;
        }
        .t2{
          font-size: 10px;
          background: #fff8f0;
          border-radius: 14px;
          padding: 0px 3px;
          color: #cb5d02;
        }
      }
    }

  }
  /* 隐藏所有控件 */
  .minimal-video::-webkit-media-controls {
    display: none !important;
  }

  /* 显示播放/暂停按钮 */
  .minimal-video::-webkit-media-controls-play-button {
    display: block !important;
  }

  /* 防止整体控件被移除 */
  .minimal-video::-webkit-media-controls-panel {
    display: flex !important;
  }
  padding: 10px;
  padding-bottom: 60px;
  .tu{
    position: relative;
    margin-bottom: 7px;
    img{
      border-radius: 5px;
      // height: 80px;
    }
    span{
      position: absolute;
      color: white;
      top: 33%;
      left: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      text-shadow:-1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;
    }
  }
  .video{
    margin-bottom: 7px;
  }
  .about{
    border: 1px solid #d0dcdf;
    border-radius: 5px;
    margin: 15px 0;

    .title{
      padding: 5px;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid #d0dcdf;
    }
    div{
      padding: 5px;
    }

  }
  .ygkuai{
    border: 1px solid #d0dcdf;border-radius: 5px;padding: 10px;
    .news:last-of-type {
      margin-bottom: 0;
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .news{
    display: flex;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #d0dcdf;

    .txt{
      width: 80%;
      margin-right: 5px;
      height: 63px;
      .t1{
        font-weight: bold;
        margin-bottom: 5px;
        height: 20px;
        overflow: hidden;
        white-space: nowrap;       
        text-overflow: ellipsis;   
        font-size: 13px;
      }
      .t2{
        font-size: 12px;
        color: #b5b5b5;
        height: 30px;
        line-height: 17px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;       /* 限制显示2行 */
        -webkit-box-orient: vertical;
      }
    }
    .img{
      width: 20%;
      border: 1px solid #d0dcdf;
      border-radius: 5px;
      overflow: hidden;
      font-size: 0;
      display: flex;
      align-items: center;
    }
  }
}
.activity-detail-popup {
  .block {
    margin: var(--f7-margin-size-0);
    padding: var(--f7-padding-size-0);
  }
}

.next-popup {
  color: #000;
  text-align: center;
  margin-bottom: 10px;
}

.new-player-nav-border {
  // border: 1px solid #4e4e4e;
  font-size: 0;
}

.martop {
  margin-top: -3px !important;
}

.referr {
  position: absolute;
  top: 18px;
  // right: 8px;
  padding-left: 10px;

  img {
    vertical-align: middle;
  }
}

.incenter {
  margin: 0 auto;
  display: inline-block;
}

.home-liveRates {
  // margin: 0px 16px 0px 16px;

  .title-center {
    text-align: center;
  }

  .liveRates-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0px 5px 0;
    height: 34px;
    position: relative;

    .title {
      padding-left: 10px;
      font-size: 14px;
      font-weight: bold;
    }

    .more {
      background-image: url("../static/images/yt999/home/icon_more.png");
      width: 34px;
      height: 34px;
      background-size: cover;

      .liveRate-popup {
        background: transparent;
      }
    }
  }

  .liveRates-title::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 0px;
    transform: translateX(-50%);
    width: 3px;
    height: 45%;
    background-color: var(--f7-THEME-color);
  }

  .liveRates-content {
    background-color: #f6f6f6;
    border-radius: 8px;
    padding: 16px 0px 16px 0px;

    .liveRates-name {
      font-size: 12px;
      font-weight: 600;
      margin: 0px 16px 16px 16px;
    }

    .liveRate-lists {
      overflow: hidden;

      .rate-item {
        border-bottom: 1px solid #efefef;
        margin-bottom: 12px;
        padding: 0px 0px 12px 16px;

        .country-img {
          width: 24px;
        }

        .country-name {
          font-size: 12px;
          color: #666666;
          line-height: 28px;
        }

        .increase {
          line-height: 28px;
          text-align: center;

          img {
            width: 14px;
          }
        }

        .ask {
          font: inter;
          font-size: 12px;
          font-weight: 400;
          color: #000000;
          padding-left: 40px;
          line-height: 28px;
        }
      }
    }
  }

  .icon-country {
    background-image: url("../static/images/yt999/home/country-map.png");
    background-repeat: no-repeat;
    width: 26px;
    height: 18px;
    display: inline-block;
    background-position-y: 0px;
    background-size: 324px auto;
    margin: 3px 0px 3px 0px;

    &.icon-USD {
      background-position-y: -86px;
      background-position-x: 0px;
    }

    &.icon-AUD {
      background-position-y: 0px;
      background-position-x: 0px;
    }

    &.icon-BRL {
      background-position-y: 0px;
      background-position-x: -37px;
    }

    &.icon-CAD {
      background-position-y: 0px;
      background-position-x: -74px;
    }

    &.icon-CHF {
      background-position-y: 0px;
      background-position-x: -112px;
    }

    &.icon-CNY {
      background-position-y: 0px;
      background-position-x: -149px;
    }

    &.icon-EUR {
      background-position-y: 0px;
      background-position-x: -185px;
    }

    &.icon-GBP {
      background-position-y: 0px;
      background-position-x: -224px;
    }

    &.icon-HKD {
      background-position-y: 0px;
      background-position-x: -261px;
    }

    &.icon-INR {
      background-position-y: 0px;
      background-position-x: -299px;
    }

    &.icon-JPY {
      background-position-y: -28px;
      background-position-x: 0px;
    }

    &.icon-KRW {
      background-position-y: -28px;
      background-position-x: -37px;
    }

    &.icon-MXN {
      background-position-y: -28px;
      background-position-x: -74px;
    }

    &.icon-NOK {
      background-position-y: -28px;
      background-position-x: -112px;
    }

    &.icon-NZD {
      background-position-y: -28px;
      background-position-x: -149px;
    }

    &.icon-RUB {
      background-position-y: -28px;
      background-position-x: -185px;
    }

    &.icon-SEK {
      background-position-y: -28px;
      background-position-x: -224px;
    }

    &.icon-SGD {
      background-position-y: -28px;
      background-position-x: -261px;
    }

    &.icon-TRY {
      background-position-y: -28px;
      background-position-x: -299px;
    }

    &.icon-ZAR {
      background-position-y: -57px;
      background-position-x: 0px;
    }
  }
}


.home-download {
  .content {
    padding: 16px;
    text-align: center;

    .content-text {
      p {
        font: 300 2rem/2.5rem Roboto, Helvetica Neue, sans-serif;
        font-size: 22px;
      }
    }

    .downloadLink {
      font: 400 1rem/1.5rem Roboto, Helvetica Neue, sans-serif;

      a {
        color: #000;
        text-decoration: underline;
      }
    }

    .content-text2 {
      font: 300 2rem/2.5rem Roboto, Helvetica Neue, sans-serif;
      font-size: 20px;
      margin-top: 32px;
    }

    .content-text3 {
      font: 300 2rem/2.5rem Roboto, Helvetica Neue, sans-serif;
      font-size: 12px;
      letter-spacing: 0.02em;
      line-height: 24px;
    }

    .content-text4 {
      font: 300 14px/1.25rem Roboto, Helvetica Neue, sans-serif;
      letter-spacing: 0.02em;
      line-height: 24px;
      font-weight: 400;
    }

    .downloadLink-img {
      a {
        background-size: 158px 47px;
        display: inline-block;
        cursor: pointer;
        margin: 20px 0;
        height: 47px;
        width: 158px;
      }

      .app-store {
        background-image: url("../static/images/yt999/home/google-play.png");
      }

      .google-play {
        background-image: url("../static/images/yt999/home/app-store.png");
      }
    }
  }
}

.home-login {
  background-image: url("../static/images/yt999/home/Invite-friend.png");
  background-size: cover;

  .content {
    width: 100%;
    height: 372px;
    position: relative;

    .content-text {
      padding: 16px;
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;

      p {
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        padding: 0px 16px;
      }
    }

    .content-button {
      position: absolute;
      top: 80%;
      left: 50%;
      transform: translateX(-50%);

      button {
        width: 120px;
        padding: 13px;
        border-radius: 20px;
        background-color: red;
        border: none;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.home-fraudAware {
  text-align: center;

  h2 {
    font: 300 2rem/2.5rem Roboto, Helvetica Neue, sans-serif;
    padding: 0px 20px;
    font-size: 20px !important;
  }

  p {
    font: 300 12px/1.25rem Roboto, Helvetica Neue, sans-serif;
    padding: 0px 20px;

    a {
      color: #000;
      font-weight: 600;
      text-decoration: underline;
    }
  }

  .steps-lists {
    background-color: #f6f6f6;
    display: flex;
    flex-direction: column;
    max-width: 1440px;
    margin: 0 auto;
    padding: 1.875rem 1.25rem;

    .steps-img {
      box-shadow: 0 10px 30px #d0d0d0;
      position: relative;
      margin-bottom: 2.5rem;
      background-color: #fff;
      padding: 1.875rem 1.25rem;
      display: grid;
      justify-items: center;
    }

    a {
      margin: 30px 0px;
      font: 600 12px/1.25rem Roboto, Helvetica Neue, sans-serif;
      text-decoration: underline;
      color: #4e453f;
    }
  }

  .luluMoney-logo {
    margin: 60px 0;

    img {
      width: 300px;
    }
  }
}

.home-joinToday {
  background-image: url("../static/images/yt999/home/photo-bg.png");
  background-size: cover;

  .content {
    width: 100%;
    height: 314px;
    position: relative;

    .pulsLogo-img {
      position: absolute;
      left: 6%;
      top: 6%;

      img {
        width: 100%;
        height: auto;
      }
    }

    .content-text {
      padding: 16px 16px;
      position: absolute;
      top: 30%;

      p {
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
      }
    }

    .content-button {
      position: absolute;
      top: 82%;
      left: 50%;
      transform: translateX(-50%);

      button {
        width: 120px;
        padding: 13px;
        border-radius: 20px;
        background-color: red;
        border: none;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.home-testimonials {
  text-align: center;

  .testimonials-text {
    padding: 0px 64px;

    p {
      font: 300 14px/1.25rem Roboto, Helvetica Neue, sans-serif;
      font-size: 16px;
    }
  }
}

.home-helpMarketing {
  height: 182px;
  background-color: #f6f6f6;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 38px;

  p {
    font: 300 1rem/1.5rem Roboto, Helvetica Neue, sans-serif;
    font-size: 12px;
  }
}

/* home 01 */
.home-trusted {
  text-align: center;
  // margin-top: 20px;

  .h1 {
    // border-bottom: 1px solid #e5e5e5;
    padding-top: 5px;
    line-height: 20px;
    color: white;
  }

  .h2 {
    display: flex;
    // background: #d68767;
    color: #fff0ea;
    justify-content: flex-end;
    align-items: center;
    font-size: 12px;
    border-radius: 15px;
    height: 25px;
    padding: 0 10px;
    position: absolute;
    right: 10px;
    bottom: 10px;
    border: 1px solid #f9f9f9;
    i {
      font-size: 22px;
      padding-right: 4px;
    }
  }
}

.home-trusted ul li {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

.home-trusted ul li {
  position: relative;
  width: 60%;
  min-height: 100px;
  margin-right: 4%;
  padding-left: 35%;
  // background-image: url(../static/images/yt999/home/trusted_1.png);
  // background-size: 1200px auto;
  background-size: cover;
  font-size: 12px;
  margin-top: 10px;
  margin: 0 3.5% 15px 0;
  //padding: 0 0 0 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.plain {
  ul {
    line-height: 22px;
    box-sizing: border-box;
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }

  .img-title {
    position: absolute;
    left: 2%;
    top: 0;
    height: 100px;
  }

  box-sizing: border-box;
  width: 100%;
  /* padding-right: 15px; */
  /* padding-left: 15px; */
  margin-right: auto;
  margin-left: auto;
  margin-top: 15px;

  strong {
    font-weight: bolder;
  }

  .heading {
    width: 90%;
    background-image: url("../static/images/yt999/music/heading.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-size: 14px;
    line-height: 30px;
    padding: 10px;
    border-radius: 8px;
    display: inline-block;
    text-align: left;
    color: #71391c;
    height: 90px;
  }

  ul,
  li {
    padding: 0;
    margin: 10px;
    list-style: none;
  }

  h1 {
    font-size: 40px;
  }

  h2 {
    font-size: 35px;
  }

  h3 {
    font-size: 30px;
  }

  h4 {
    font-size: 25px;
  }

  h5 {
    font-size: 20px;
  }
}

/* home 01 */

/* home 02 */
#checkout-cb-explainer {
  display: flex;
  background-color: #525255;
  color: #fff;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 15%);
  margin-bottom: 30px;
  height: 165px;
}

#checkout-cb-explainer .title {
  width: 140px;
  font-size: 18px !important;
  line-height: 20px !important;
  padding-right: 0;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

#checkout-cb-explainer .title .wrap:before {
  display: block;
  content: "";
  width: 50px;
  height: 26px;
  margin: 2px 0;
  background: url(../static/images/yt999/home/ob-cashback-lettermark.svg) left center / auto 26px no-repeat;
}

#checkout-cb-explainer .title .wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

#checkout-cb-explainer .title .wrap > * {
  height: 22px;
}

#checkout-cb-explainer .scrolling {
  width: 50vw;
  flex-grow: 1;
  flex-shrink: 1;
  margin: 12px 10px 10px;
  align-self: center;
  position: relative;
  margin-top: 0px !important;
}

#checkout-cb-explainer .point {
  /*width: 105%!important;*/
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0px;
  /*padding-right: 5px;*/
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  text-align: left;
}

#checkout-cb-explainer .title {
  width: 135px;
  font-size: 22px;
  line-height: 20px;
  padding-right: 0;
  color: #36c;
  background-color: #fff;
  margin-right: 10px;
  padding: 30px 15px;
  position: relative;
  font-weight: 700;
  font-size: 30px;
  line-height: 28px;
  z-index: 1;
  letter-spacing: -0.02em;
  display: flex;
  align-items: center;
}

.plain {
  width: 100%;
  /*padding-right: 15px;*/
  /*padding-left: 15px;*/
  margin-right: auto;
  margin-left: auto;
}

.ui-container {
  overflow: hidden;
  /*width: 200px;*/
  /*height: 50px;*/
}

.ui-slider {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  transition: margin 0.5s;
  /* 添加过渡效果 */
}

#checkout-cb-explainer .point-title {
  font-weight: 700;
  color: #ffc56a;
  font-size: 22px;
  margin-bottom: 0;
}

#checkout-cb-explainer .title:after {
  position: absolute;
  top: -15px;
  right: -10px;
  bottom: -15px;
  width: 30px;
  content: "";
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 15px, #fff 15px, #fff 51%, rgba(0, 0, 0, 0) 51%), linear-gradient(to top, rgba(0, 0, 0, 0) 15px, #fff 15px, #fff 51%, rgba(0, 0, 0, 0) 51%);
  border-radius: 0 180% 180% 0;
  z-index: -1;
}

/* home 02 */

/* home 03 */

.containerhome03 {
  width: 100%;
  // padding-right: 15px;
  // padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
}

.containerhome03 div {
  border-style: hidden !important;
  box-sizing: unset;
}

.shadow {
  box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.1) !important;
  -webkit-box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.1) !important;
  -moz-box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.1) !important;
  -ms-box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.1) !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.card {
  // border-radius: 10px;
  // border: 0;
  // position: relative;
  // display: -ms-flexbox;
  // display: flex;
  // -ms-flex-direction: column;
  // flex-direction: column;
  // min-width: 0;
  // word-wrap: break-word;
  // background-color: #fff;
  // background-clip: border-box;
  // border: 1px solid rgba(0,0,0,.125);
  // border-radius: 0.25rem;

  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
    margin-top: 0;
  }
}

/* home 03 */

/* vip */
.container {
  padding-right: 0;
  padding-left: 0;
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  .container_vip_title {
    width: 100%;
    display: block;
    font-size: 20px;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .vip_div {
    text-align: center;
    margin-top: 10px;

    .vip {
      text-align: center;
      width: 100%;

      .pic {
        width: 50%;
        float: left;
        height: 10%;

        .s1 {
          float: left;
          position: absolute;
          color: #ffffff;
          font-size: 8px;
          text-align: left;
          width: 65px;
          margin-left: 3px;
          margin-top: 8.5%;
        }

        .s2 {
          position: absolute;
          color: #ffffff;
          font-size: 8px;
          text-align: left;
          width: 70px;
          margin-left: 3px;
          margin-top: 12%;
        }

        .s3 {
          float: left;
          position: absolute;
          color: #ffffff;
          font-size: 8px;
          text-align: left;
          width: 130px;
          margin-left: 3px;
          margin-top: 15.5%;
        }

        .s4 {
          position: absolute;
          color: #ffffff;
          width: 13%;
          margin-left: 31%;
          margin-top: 8%;
          font-size: 15px;
          text-align: center;
        }

        .s4-active {
          position: absolute;
          color: #ffdd8d;
          width: 13%;
          margin-left: 31%;
          margin-top: 8%;
          font-size: 15px;
          text-align: center;
        }

        .img1 {
          border-radius: 10px;
          margin-top: -3px;
          margin-right: 2px;
          width: 95%;
        }
      }
    }
  }

  .vip_div ul li:nth-of-type(1) {
    text-align: right;
  }

  .vip_div ul li:nth-of-type(2) {
    text-align: left;
  }

  .vip_div ul li:nth-of-type(3) {
    text-align: right;
  }

  .vip_div ul li:nth-of-type(4) {
    text-align: left;
  }

  .vip_div ul li:nth-of-type(5) {
    text-align: right;
  }

  .vip_div ul li:nth-of-type(6) {
    text-align: left;
  }

  .vip_div ul li:nth-of-type(7) {
    text-align: right;
  }

  .vip_div ul li:nth-of-type(8) {
    text-align: left;
  }

  .vip_div ul li:nth-of-type(9) {
    text-align: right;
  }

  .vip_div ul li:nth-of-type(10) {
    text-align: left;
  }
}

/* vip */

.tabs-games {
  padding-bottom: 88px;

  /deep/ .van-tabs__wrap {
    box-shadow: 0px 0px 8px 0px rgba(104, 0, 255, 0.18);

    .van-tabs__nav {
    }
  }

  /deep/ .van-tab__text {
    display: flex;
    position: relative;
    align-items: center;
    background-color: #f3f3f3;
    border-radius: 25px;
    padding: 4px 18px 4px 38px;
    height: 20px;
    font-size: 12px;
    box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.1);

    img {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 32px;
    }
  }

  /deep/ .van-tab--active {
    &.title-SportsBook .van-tab__text {
      background: linear-gradient(45deg, #4fe387, #6ce164);
      color: #fff;
    }

    &.title-Casino .van-tab__text {
      background: linear-gradient(45deg, #56c2f2, #3cacf6);
      color: #fff;
    }

    &.title-Egames .van-tab__text {
      background: linear-gradient(45deg, #f8ae4f, #f79b2b);
      color: #fff;
    }

    &.title-Lottery .van-tab__text {
      background: linear-gradient(45deg, #f84fe6, #f72fc8);
      color: #fff;
    }

    &.title-Card .van-tab__text {
      background: linear-gradient(45deg, #efb190, #dd8864);
      color: #fff;
    }

    &.title-Fish .van-tab__text {
      background: linear-gradient(45deg, #3b7aee, #2033af);
      color: #fff;
    }
  }

  .tab-content {
    display: flex;
    flex-wrap: wrap;
    padding: 6px 5px;

    .game-item {
      position: relative;
      width: 33.333333%;
      text-align: center;
      margin-bottom: 5px;
      box-sizing: border-box;

      .bg {
        width: calc(100% - 10px);
      }

      .item-inner {
        position: absolute;
        bottom: 10px;
        left: 15px;
        right: 15px;

        color: #fff;

        .logo {
          line-height: 0;
          height: 28px;

          text-align: left;

          img {
            height: 100%;
          }
        }

        .name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        }

      }
    }

    .fish-item {
      margin-bottom: 10px;

      img {
        border-radius: 8px 8px 0 0;
        height: calc(100% - 44px);
        min-height: 100px;
        background: #f3f3f3;
      }

      .item-inner {
        margin: -5px auto 0;
        padding: 3px 0;
        font-weight: 500;
        position: unset;
        background-color: #569add;
        width: calc(100% - 10px);
        border-radius: 0 0 8px 8px;
        min-height: 40px;
      }
    }
  }
}

.fab-contaienr {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: var(--f7-fab-size);
  height: var(--f7-fab-size);

  .bg-image {
    width: 50px;
    height: 50px;
  }

  .icon-close {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
  }
}

.music-img {
  margin: 5px 0px;
  display: flex;

  .music-logo {
    width: 20%;

    img {
      border-radius: 8px;
      border: 1px solid #d9d6d6;
    }
  }

  .music-info {
    width: 70%;
    line-height: 40px;
    padding-left: 20px;
    overflow: hidden;
    .music-author {
      color: #ccc;
      color: #818181;
      font-size: 13px;
    }

    span {
      display: block;
      height: 28px;
    }

    .music-name {
      // position: relative;
      // top: 7px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: bold;
    }
  }

  .music-go {
    width: 10%;
    align-content: center;
    margin-left: 7px;
    img {
      width: 28px !important;
    }
  }
}

.product-container {
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid var(--f7-common-border-color);
  font-size: 14px;
  text-align: center;
  margin-bottom: 30px;
  padding: 10px 0;

  p {
    margin: 0;
    /* 去除段落的默认边距 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
  }

  .bold-black {
    font-weight: bold;
    /* 加粗 */
    color: #000000;
    /* 黑色字体 */
  }

  .red-text {
    font-weight: 800;
    color: #ff0000;
    /* 红色字体 */
  }

  .grey-text {
    color: #808080;
    /* 灰色字体 */
    font-size: 12px;
    /* 小字体 */
  }

  .black-text {
    color: #000000;
    max-height: 40px;
    /* 黑色字体 */
  }

  .button {
    background-color: var(--f7-THEME-color);
    color: #ffffff;
    border-radius: 20px;
    text-align: center;
    margin: 0px auto;
    display: block;
    height: 35px;
    line-height: 35px;
    width: 100px;
    text-transform: none;
  }
}

.chanping {
  width: 48%;
  margin-right: 2%;
}

.ios .page-home .main-suggest-content .swiper-slide {
  justify-content: left;
}
.ios .page-home .main-suggest-content .swiper-slide img {
  width: 70px;
}

.main-category .menu {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr; /* 每个子元素占据1/3的宽度 */
  grid-gap: 10px;
  /* 设置网格项之间的间距 */

  img {
    display: block;
    margin: 0 auto;
    width: 35px;
    margin-bottom: 7px;
  }

  span {
    display: block;
    text-align: center;
    font-size: 13px;
  }
  .news {
    position: relative;
  }
  .messageNum {
    position: absolute;
    top: 0px;
    left: 30%;
    height: 16px;
    width: 16px;
    line-height: 16px;
    color: white;
    background: red;
    border-radius: 10px;
    font-size: 12px;
    text-align: center;
  }
}

.ios .page-home .main-suggest-content {
  position: relative;
  left: -12px;
}
.dialog-message .dialog-inner .dialog-text .block-message .row-toggle span {
  color: #000;
}
::v-deep.toggle input[type="checkbox"]:checked + .toggle-icon {
  background: var(--f7-THEME-color);
}
.dialog-redPacket {
  width: 74%;
  margin: 0 9%;
  padding: 0 15px 30px 15px;
  background: url("../static/images/yt999/home/red/kuang.png");
  background-size: 100% 100%;
  // border: 1px solid rgba(177,177,177,0.58);
  left: 0;

  .dialog-inner {
    padding: 0;
    text-align: left;

    .dialog-title {
      text-align: center;
      position: relative;
      font-size: 18px;
      padding-bottom: 4px;
      color: #423232;
      .title {
        margin: 35px 0 -15px 0;
        font-size: 16px;
        font-weight: bold;
        color: var(--f7-THEME-color);
      }

      h5 {
        margin: 0;
        font-weight: normal;
      }
    }
    .line {
      position: relative;
      margin: 0px 0 40px 0px !important;
    }
    .dialog-title:after,
    .line::after {
      content: "";
      z-index: 1;
      background: url(../static/images/yt999/home/red/xian.png) no-repeat;
      background-size: var(--f7-size-percent-100) var(--f7-size-percent-100);
      width: 50%;
      display: block;
      transform-origin: 50% 100%;
      transform: scaleY(1);
      transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
      height: 35px;
      margin: 0 auto;
    }

    .dialog-text {
      .block-message {
        margin: var(--f7-margin-size-0);
        padding: var(--f7-padding-size-0);
        width: var(--f7-width-size-pt100);

        .block-content {
          padding: var(--f7-padding-size-8) var(--f7-padding-size-10);
          overflow: hidden scroll;
          font-size: 15px;
          .tipp {
            margin-bottom: 10px;
            padding-left: 8px;
            font-size: 14px;
          }
          p {
            margin: 0;
          }
          .input-code {
            height: 100px;
            border: 1px solid #e2e2e2;
            width: 96%;
            border-radius: 4px;
            margin-left: 2%;
            padding: 8px;
            background: #fbfbfb;
            color: #7b7b7b;
            font-size: 13px;
          }
          .input-with-value {
            color: #013792;
          }
          .red-packet-message {
            font-size: 13px;
            margin-bottom: -8px;
            text-align: center;
            color: #ed2d2d;
            height: 42px;
          }
          .btn {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 10px;
            color: white;
            text-align: center;
            margin: 10px;
            .btn1 {
              background: #6d6d6d;
              border-radius: 5px;
              height: 30px;
              line-height: 30px;
              font-size: 14px;
            }
            .btn2 {
              background: var(--f7-THEME-color);
              border-radius: 5px;
              height: 30px;
              line-height: 30px;
              font-size: 14px;
            }
          }
        }

        .row-toggle {
          margin: 10px 10px 0;

          span {
            color: #40baff;
          }

          .toggle {
            margin-top: var(--f7-margin-size-f2);
          }
        }

        .block-footer {
          margin-top: 8px;

          .row.no-gap {
            --f7-grid-gap: 0px;
          }

          .button {
            height: 50px;
            line-height: 50px;
            color: var(--f7-color-white);
            font-size: var(--f7-px-14);
          }

          .btn-next {
            background-color: #ccc;
            color: #101010;
          }

          .btn-next.button-disabled {
            opacity: 0.6;
            color: #101010 !important;
          }

          .btn-close {
            background-color: var(--f7-THEME-color);
            color: white !important;
            border-radius: 0;
          }
        }
      }
    }
  }
}
.dialog-redPacketDetail {
  width: 74%;
  margin: 0 9%;
  padding: 0 15px 30px 15px;
  background: url("../static/images/yt999/home/red/kuang.png");
  background-size: 100% 100%;
  // border: 1px solid rgba(177,177,177,0.58);
  left: 0;

  .dialog-inner {
    padding: 0;
    text-align: left;

    .dialog-title {
      text-align: center;
      position: relative;
      font-size: 18px;
      padding-bottom: 4px;
      color: #423232;
      .title {
        margin: 35px 0 -15px 0;
        font-size: 16px;
        font-weight: bold;
        color: red;
      }

      h5 {
        margin: 0;
        font-weight: normal;
      }
    }
    .line {
      position: relative;
      margin: 0px 0 40px 0px !important;
    }
    .dialog-title:after,
    .line::after {
      content: "";
      z-index: 1;
      background: url(../static/images/yt999/home/red/xian.png) no-repeat;
      background-size: var(--f7-size-percent-100) var(--f7-size-percent-100);
      width: 50%;
      display: block;
      transform-origin: 50% 100%;
      transform: scaleY(1);
      transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
      height: 35px;
      margin: 0 auto;
    }

    .dialog-text {
      .block-message {
        margin: var(--f7-margin-size-0);
        padding: var(--f7-padding-size-0);
        width: var(--f7-width-size-pt100);

        .block-content {
          padding: var(--f7-padding-size-8) var(--f7-padding-size-10);
          overflow: hidden scroll;
          font-size: 15px;
          text-align: center;
          .tipp {
            margin-bottom: 10px;
            padding-left: 8px;
            font-size: 14px;
          }
          p {
            margin: 0;
          }
          .input-code {
            height: 100px;
            border: 1px solid #e2e2e2;
            width: 96%;
            border-radius: 4px;
            margin-left: 2%;
            padding: 8px;
            background: #fbfbfb;
            color: #7b7b7b;
            font-size: 13px;
          }
          .red-packet-message {
            margin-bottom: -8px;
            text-align: center;
            color: #101010;
          }
          .money {
            color: red;
            font-weight: bold;
            font-size: 18px;
            margin: 10px;
          }
          .btn {
            background: red;
            color: white;
            text-align: center;
            margin: 10px auto;
            width: 50%;
            height: 30px;
            line-height: 30px;
            border-radius: 5px;
          }
        }

        .row-toggle {
          margin: 10px 10px 0;

          span {
            color: #40baff;
          }

          .toggle {
            margin-top: var(--f7-margin-size-f2);
          }
        }

        .block-footer {
          margin-top: 8px;

          .row.no-gap {
            --f7-grid-gap: 0px;
          }

          .button {
            height: 50px;
            line-height: 50px;
            color: var(--f7-color-white);
            font-size: var(--f7-px-14);
          }

          .btn-next {
            background-color: #ccc;
            color: #101010;
          }

          .btn-next.button-disabled {
            opacity: 0.6;
            color: #101010 !important;
          }

          .btn-close {
            background-color: var(--f7-THEME-color);
            color: white !important;
            border-radius: 0;
          }
        }
      }
    }
  }
}

.bonusv0 {
  width: 80%;
  //  height: 40%;
  border-radius: 20px;
  text-align: center;
  overflow-y: visible;

  img {
    width: 100%;
    position: relative;
    top: -68px;
    z-index: 2005;
  }
  .go {
    width: 70%;
    height: 40px;
    line-height: 40px;
    background: var(--f7-THEME-color);
    margin: 0 auto;
    border-radius: 10px;
    color: white;
    font-weight: bold;
    margin-bottom: 33px;
  }
  ::v-deep .van-popup__close-icon--top-right {
    top: auto;
    right: 45%;
    bottom: -40px;
  }
  ::v-deep .van-popup__close-icon {
    font-size: 33px;
  }
}
.bonusv1 {
  width: 80%;
  //  height: 40%;
  border-radius: 20px;
  text-align: center;
  overflow-y: visible;

  img {
    width: 100%;
    position: relative;
    top: -68px;
    z-index: 2005;
  }
  .go {
    width: 70%;
    height: 40px;
    line-height: 40px;
    background: var(--f7-THEME-color);
    margin: 0 auto;
    border-radius: 10px;
    color: white;
    font-weight: bold;
    margin-bottom: 33px;
  }
  ::v-deep .van-popup__close-icon--top-right {
    top: auto;
    right: 45%;
    bottom: -40px;
  }
  ::v-deep .van-popup__close-icon {
    font-size: 33px;
  }
}
.dialog-popupAd {
  .close {
    position: absolute;
    top: -35px;
    right: 0px;
    width: 32px;
  }
  .left {
    position: absolute;
    bottom: -40px;
    left: 10px;
    z-index: 100;
  }
  .right {
    position: absolute;
    bottom: -40px;
    right: 10px;
    z-index: 100;
  }
  .swiper-pagination {
    width: 100%;
    padding-top: 10px;
  }
  ::v-deep .swiper-pagination-bullet {
    background: #ffffff;
    opacity: 0.5;
    margin-right: 8px;
  }
  ::v-deep .swiper-pagination-bullet-active {
    opacity: 1;
    background: #ffd158;
  }
}
.licaics{
  width: 100%;
  .kuai{
    display: flex;
    padding: 10px 0;
    border: 1px solid var(--f7-THEME-color);
    border-radius: 8px;
    margin-bottom: 10px;
    height: 65px;
    position: relative;
    font-size: 12px;
    .one{
      width: 28%;
      text-align: center;
      img{
        border: 1px solid #ccc;
        border-radius: 5px;
        width: auto;
        height: 65px;
      }
    }
    .two{
      width: 70%;
      height: 65px;
      display: grid;
      align-items: center;
      p{
        margin: 0;
        width: 100%;

      }
      p:nth-child(2){
        color: #999999;
      }
      .name{
        white-space: nowrap;        /* 禁止换行 */
        overflow: hidden;           /* 超出部分隐藏 */
        text-overflow: ellipsis;    /* 超出部分显示省略号 */
        font-weight: bold;
        width: 90%;
        font-size: 13px;
      }
      .name2{
        white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 90%;
      }
      .rb{
        font-size: 14px;
        font-weight: bold;
        color: red;
      }
    }
    .jian{
      color: var(--f7-THEME-color);
      position: absolute;
      top: 31px;
      right: 10px;
      font-size: 18px;
    }
  }

}

.van {
  padding: 5px 15px;
  background: var(--f7-THEME-color2);
  border-radius: 8px;
  ul li {
    height: 52px;
    text-align: center;
    border-bottom: 1px solid #d9d9d9;
  }
  li:nth-child(10) {

    border-bottom: 0;
  }

  .title {
    display: flex;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #d9d9d9;
    font-weight: bold;
  }

  .d1 {
    width: 33%;
    position: relative;

    .boxnum {
      position: absolute;
      top: 14px;
      font-weight: bold;
      font-size: 17px;
      width: 100%;
      text-align: center;
      left: 0;
    }
  }

  .d2 {
    width: 50%;
    line-height: 55px;
    font-weight: bold;
    color: red;
    .fun {
      width: 10px;
      height: 10px;
      display: inline-block;
      background: #ccc;
      border-radius: 10px;
      position: absolute;
      left: -5px;
      top: 23px;
    }
  }

  .d3 {
    width: 50%;
    line-height: 55px;
    font-size: 16px;
    display: flex;
    align-items: center;   /* 垂直方向居中 */
    justify-content: center; /* 水平方向居中（整体居中可选） */
  }

  ::v-deep.van-tabs--line .van-tabs__wrap {
    border-radius: 10px 10px 0 0;
    height: 0;
  }

  ::v-deep .van-tab__text--ellipsis {
    font-weight: bold;
  }

  .fun2 {
    width: 10px;
    height: 10px;
    display: inline-block;
    background: #ccc;
    border-radius: 10px;
    margin: 10px 10px 0 10px;
  }

  ::v-deep .van-tab--active {
    color: #323233;
    font-weight: 500;
    // background: linear-gradient(to bottom, var(--f7-THEME-color), #fff);
    background: linear-gradient(179.62deg, #009DD2 0.33%, #FFFFFF 99.67%);
    border-radius: 10px 10px 0 0;
  }

  ::v-deep .van-tabs__line {
    display: none;
  }

  ::v-deep .van-tabs__nav {
    background-color: #f0f0f0;
  }
}
.vipgo {
  margin-bottom:10px;
  background-size: cover;
  border-radius: 5px;
  background-image: url("../static/images/yt999/music/viplevel.png");
  background-repeat: no-repeat;
  background-size: 100% 99%;
  .logo{
    width: 28%;
    text-align: center;
    padding-top: 6px;
    margin: 0 5px;
    align-items: center;
    display: flex;
  }
  .text1 {
    margin-top: 13px;
    font-size: 16px;
    color: var(--f7-THEME-color);
    font-weight: bold;
    padding-right: 5px;
  }
  .text2 {
    margin-top: 5px;
    font-size: 12px;
    color: #000;
  }
  .text3 {
    margin-top: 5px;
    overflow-wrap: break-word;
    font-size: 12px;
    color: var(--f7-THEME-color);
    padding-right: 5px;
    text-decoration: underline;
    padding-left: 32px;
    position: relative;
    
  }

  .red-button {
    margin: 10px 0px;
    color: #fff;
    border-radius: 15px;
    padding: 10px 10px;
    font-size: 14px;
    display: inline-block;
    text-align: center;
    // height: 12px;
    line-height: 12px;
    background: linear-gradient(to bottom, var(--f7-THEME-color2), var(--f7-THEME-color));
  }
}
</style>
